/* eslint-disable @typescript-eslint/no-explicit-any */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: { input: any; output: any };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
};

/** Autogenerated input type of ActivateBackup */
export type IActivateBackupInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ActivateBackup. */
export type IActivateBackupPayload = {
  __typename?: 'ActivateBackupPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum ActivityNotificationEnum {
  Each = 'each',
  First = 'first',
}

/** Autogenerated input type of Add */
export type IAddInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  users: Array<IUserInput>;
};

/** Autogenerated return type of Add. */
export type IAddPayload = {
  __typename?: 'AddPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  users?: Maybe<Array<IUser>>;
};

export type IAddon = {
  __typename?: 'Addon';
  currencyCode: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  period: Scalars['Int']['output'];
  periodUnit: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Int']['output'];
};

export type IAgreement = {
  __typename?: 'Agreement';
  agreementForm?: Maybe<AgreementFormEnum>;
  approved: Scalars['Boolean']['output'];
  approvedByBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  approvedByCodekeeper?: Maybe<Scalars['Boolean']['output']>;
  approvedByDepositor?: Maybe<Scalars['Boolean']['output']>;
  conditions: Array<AgreementConditionEnum>;
  conditionsOther?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  draft: Scalars['Boolean']['output'];
  events: Array<IAgreementEvent>;
  id: Scalars['ID']['output'];
  jurisdiction?: Maybe<JurisdictionEnum>;
  legalContext: Array<LegalContextEnum>;
  legalContextOther?: Maybe<Scalars['String']['output']>;
  liability?: Maybe<LiabilityEnum>;
  policy: IAgreementPolicy;
  protectionPeriod?: Maybe<ProtectionPeriodEnum>;
  terms?: Maybe<Scalars['String']['output']>;
  termsDownloadDocxUrl?: Maybe<Scalars['String']['output']>;
  termsDownloadPdfUrl?: Maybe<Scalars['String']['output']>;
  termsSignedDownloadPdfUrl?: Maybe<Scalars['String']['output']>;
  thirdPartyAgreement: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AgreementApprove */
export type IAgreementApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of AgreementApprove. */
export type IAgreementApprovePayload = {
  __typename?: 'AgreementApprovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow?: Maybe<IEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export type IAgreementChangeParams = {
  conditions?: InputMaybe<Array<AgreementConditionEnum>>;
  conditionsOther?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<JurisdictionEnum>;
  legalContext?: InputMaybe<Array<LegalContextEnum>>;
  legalContextOther?: InputMaybe<Scalars['String']['input']>;
  liability?: InputMaybe<LiabilityEnum>;
  protectionPeriod?: InputMaybe<ProtectionPeriodEnum>;
};

export enum AgreementConditionEnum {
  Bankruptcy = 'bankruptcy',
  Insolvency = 'insolvency',
  Maintenance = 'maintenance',
  Other = 'other',
}

export type IAgreementEvent = IEventInterface & {
  __typename?: 'AgreementEvent';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: Scalars['String']['output'];
  payload: IAgreement;
};

export enum AgreementFormEnum {
  Bipartite = 'bipartite',
  Tripartite = 'tripartite',
}

/** Autogenerated input type of AgreementGenerate */
export type IAgreementGenerateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of AgreementGenerate. */
export type IAgreementGeneratePayload = {
  __typename?: 'AgreementGeneratePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow?: Maybe<IEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export type IAgreementPolicy = {
  __typename?: 'AgreementPolicy';
  approve: Scalars['Boolean']['output'];
  download: Scalars['Boolean']['output'];
  generate: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AgreementUpdate */
export type IAgreementUpdateInput = {
  agreementParams: IAgreementUpdateParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

export type IAgreementUpdateParams = {
  conditions?: InputMaybe<Array<AgreementConditionEnum>>;
  conditionsOther?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<JurisdictionEnum>;
  legalContext?: InputMaybe<Array<LegalContextEnum>>;
  legalContextOther?: InputMaybe<Scalars['String']['input']>;
  liability?: InputMaybe<LiabilityEnum>;
  protectionPeriod?: InputMaybe<ProtectionPeriodEnum>;
  thirdPartyAgreement?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AgreementUpdate. */
export type IAgreementUpdatePayload = {
  __typename?: 'AgreementUpdatePayload';
  agreement?: Maybe<IAgreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow?: Maybe<IEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export type IApp = {
  __typename?: 'App';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  criticality?: Maybe<AppCriticalityEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includedApps?: Maybe<Array<Scalars['String']['output']>>;
  industry?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  kind: AppKindEnum;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owned: Scalars['Boolean']['output'];
  ownerName: Scalars['String']['output'];
  ownerWebsite?: Maybe<Scalars['String']['output']>;
  policy: IAppPolicy;
  softwareType?: Maybe<Scalars['String']['output']>;
  taskCounts: Array<ITaskCount>;
  unclaimed: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum AppCertificationTypeEnum {
  Certified = 'certified',
  None = 'none',
  Validated = 'validated',
  Verified = 'verified',
}

/** Autogenerated input type of AppCreate */
export type IAppCreateInput = {
  appParams: IAppCreateParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type IAppCreateParams = {
  criticality: AppCriticalityEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  includedApps?: InputMaybe<Array<Scalars['String']['input']>>;
  industry: Scalars['String']['input'];
  jurisdiction: Scalars['String']['input'];
  kind: AppKindEnum;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  softwareType: Scalars['String']['input'];
};

/** Autogenerated return type of AppCreate. */
export type IAppCreatePayload = {
  __typename?: 'AppCreatePayload';
  app?: Maybe<IApp>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum AppCriticalityEnum {
  BusinessCritical = 'business_critical',
  Important = 'important',
  Standard = 'standard',
}

export enum AppKindEnum {
  Single = 'single',
  Suite = 'suite',
}

/** Autogenerated input type of AppLinkProducts */
export type IAppLinkProductsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  sourceAppId: Scalars['ID']['input'];
  targetAppId: Scalars['ID']['input'];
};

/** Autogenerated return type of AppLinkProducts. */
export type IAppLinkProductsPayload = {
  __typename?: 'AppLinkProductsPayload';
  app?: Maybe<IApp>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AppLogoDirectUpload */
export type IAppLogoDirectUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of AppLogoDirectUpload. */
export type IAppLogoDirectUploadPayload = {
  __typename?: 'AppLogoDirectUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  headers?: Maybe<Scalars['JSON']['output']>;
  signedId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type IAppMembership = {
  __typename?: 'AppMembership';
  id: Scalars['ID']['output'];
  policy: IAppMembershipPolicy;
  role: AppMembershipRoleEnum;
  user: IUser;
};

export type IAppMembershipCreateParams = {
  role?: InputMaybe<AppMembershipRoleEnum>;
  userId: Scalars['ID']['input'];
};

export type IAppMembershipPage = {
  __typename?: 'AppMembershipPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAppMembership>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IAppMembershipParams = {
  role?: InputMaybe<AppMembershipRoleEnum>;
};

export type IAppMembershipPolicy = {
  __typename?: 'AppMembershipPolicy';
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AppMembershipRemove */
export type IAppMembershipRemoveInput = {
  appMembershipId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppMembershipRemove. */
export type IAppMembershipRemovePayload = {
  __typename?: 'AppMembershipRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum AppMembershipRoleEnum {
  Manager = 'manager',
  Viewer = 'viewer',
}

/** Autogenerated input type of AppMembershipUpdate */
export type IAppMembershipUpdateInput = {
  appMembershipId: Scalars['ID']['input'];
  appMembershipParams: IAppMembershipParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppMembershipUpdate. */
export type IAppMembershipUpdatePayload = {
  __typename?: 'AppMembershipUpdatePayload';
  appMembership?: Maybe<IAppMembership>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AppMembershipsCreate */
export type IAppMembershipsCreateInput = {
  appId: Scalars['ID']['input'];
  appMembershipsParams: Array<IAppMembershipCreateParams>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppMembershipsCreate. */
export type IAppMembershipsCreatePayload = {
  __typename?: 'AppMembershipsCreatePayload';
  appMemberships?: Maybe<Array<IAppMembership>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum AppMembershipsOrderByEnum {
  Email = 'email',
  Name = 'name',
  Role = 'role',
}

export type IAppPage = {
  __typename?: 'AppPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IApp>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IAppPolicy = {
  __typename?: 'AppPolicy';
  createBackup: Scalars['Boolean']['output'];
  createCustodianProfile: Scalars['Boolean']['output'];
  createEscrow: Scalars['Boolean']['output'];
  createMemberships: Scalars['Boolean']['output'];
  linkProducts: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  readMemberships: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export enum AppProductTypeEnum {
  Backup = 'backup',
  ContinuityEscrow = 'continuity_escrow',
  CustodianProfile = 'custodian_profile',
  SaasEscrow = 'saas_escrow',
  SoftwareEscrow = 'software_escrow',
}

export type IAppProtectionAssuranceSummary = {
  __typename?: 'AppProtectionAssuranceSummary';
  backupsCount: Scalars['Int']['output'];
  certificationCertifiedCount: Scalars['Int']['output'];
  certificationCertifiedPercentage: Scalars['Float']['output'];
  certificationValidatedCount: Scalars['Int']['output'];
  certificationValidatedPercentage: Scalars['Float']['output'];
  certificationVerifiedCount: Scalars['Int']['output'];
  certificationVerifiedPercentage: Scalars['Float']['output'];
  custodianProfilesCount: Scalars['Int']['output'];
  escrowsCount: Scalars['Int']['output'];
  totalProtectionsCount: Scalars['Int']['output'];
};

export type IAppProtectionInterface = {
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  app: IApp;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  productType: AppProductTypeEnum;
  taskCounts: Array<ITaskCount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum AppProtectionStatusEnum {
  AccessSetup = 'access_setup',
  Active = 'active',
  AdminReview = 'admin_review',
  Draft = 'draft',
  Error = 'error',
  Onboarding = 'onboarding',
  PendingTermination = 'pending_termination',
  Setup = 'setup',
  Signed = 'signed',
  Terminated = 'terminated',
}

/** Autogenerated input type of AppRemove */
export type IAppRemoveInput = {
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppRemove. */
export type IAppRemovePayload = {
  __typename?: 'AppRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IAppRequest = {
  __typename?: 'AppRequest';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  declineReason?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  policy: IAppRequestPolicy;
  requesterCompanyName: Scalars['String']['output'];
  requesterCompanyWebsite: Scalars['String']['output'];
  status: AppRequestStatusEnum;
  vendorName: Scalars['String']['output'];
};

/** Autogenerated input type of AppRequestAccept */
export type IAppRequestAcceptInput = {
  appId: Scalars['ID']['input'];
  appRequestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppRequestAccept. */
export type IAppRequestAcceptPayload = {
  __typename?: 'AppRequestAcceptPayload';
  appRequest?: Maybe<IAppRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AppRequestCreate */
export type IAppRequestCreateInput = {
  appRequestParams: IAppRequestParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppRequestCreate. */
export type IAppRequestCreatePayload = {
  __typename?: 'AppRequestCreatePayload';
  appRequest?: Maybe<IAppRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AppRequestDecline */
export type IAppRequestDeclineInput = {
  appRequestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppRequestDecline. */
export type IAppRequestDeclinePayload = {
  __typename?: 'AppRequestDeclinePayload';
  appRequest?: Maybe<IAppRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IAppRequestPage = {
  __typename?: 'AppRequestPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAppRequest>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IAppRequestParams = {
  appName?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
};

export type IAppRequestPolicy = {
  __typename?: 'AppRequestPolicy';
  accept: Scalars['Boolean']['output'];
  decline: Scalars['Boolean']['output'];
};

export enum AppRequestStatusEnum {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending',
}

export enum AppRequestsKindEnum {
  Declined = 'declined',
  Received = 'received',
  Sent = 'sent',
}

export type IAppSubscription = {
  __typename?: 'AppSubscription';
  id: Scalars['ID']['output'];
  user: IUser;
};

export type IAppSubscriptionPage = {
  __typename?: 'AppSubscriptionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAppSubscription>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum AppSubscriptionsOrderByEnum {
  Email = 'email',
  Name = 'name',
}

export type IAppSuggestion = {
  __typename?: 'AppSuggestion';
  criticality: AppCriticalityEnum;
  description: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  name: Scalars['String']['output'];
  softwareType: Scalars['String']['output'];
};

/** Autogenerated input type of AppUpdate */
export type IAppUpdateInput = {
  appId: Scalars['ID']['input'];
  appParams: IAppUpdateParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type IAppUpdateParams = {
  criticality?: InputMaybe<AppCriticalityEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  includedApps?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<AppKindEnum>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  softwareType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppUpdate. */
export type IAppUpdatePayload = {
  __typename?: 'AppUpdatePayload';
  app?: Maybe<IApp>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ApplyCoupon */
export type IApplyCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponCode: Scalars['String']['input'];
};

/** Autogenerated return type of ApplyCoupon. */
export type IApplyCouponPayload = {
  __typename?: 'ApplyCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: ICompany;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IAsset = {
  __typename?: 'Asset';
  contentType?: Maybe<AssetContentTypeEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  depositMethod: DepositMethodEnum;
  depositSource?: Maybe<Scalars['String']['output']>;
  depositStatus: DepositStatusEnum;
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration?: Maybe<IIntegrationInterface>;
  lastUpdateCheck?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestDeposit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  policy: IAssetPolicy;
  size?: Maybe<Scalars['BigInt']['output']>;
  softwareEscrow: ISoftwareEscrowInterface;
  syncStatus?: Maybe<SyncStatusEnum>;
  type: AssetTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum AssetContentTypeEnum {
  Data = 'data',
  Deployment = 'deployment',
  Documentation = 'documentation',
  SourceCode = 'source_code',
  ThirdPartyDependency = 'third_party_dependency',
}

export type IAssetCount = {
  __typename?: 'AssetCount';
  count: Scalars['Int']['output'];
  latestDeposit?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of AssetCreateCustom */
export type IAssetCreateCustomInput = {
  assetsParams: Array<IAssetCreateCustomParams>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  softwareEscrowId: Scalars['ID']['input'];
};

export type IAssetCreateCustomParams = {
  contentType: AssetContentTypeEnum;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** Autogenerated return type of AssetCreateCustom. */
export type IAssetCreateCustomPayload = {
  __typename?: 'AssetCreateCustomPayload';
  assets?: Maybe<Array<IAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssetCreateOauth */
export type IAssetCreateOauthInput = {
  assetsParams: Array<IAssetCreateOauthParams>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  softwareEscrowId: Scalars['ID']['input'];
};

export type IAssetCreateOauthParams = {
  contentType: AssetContentTypeEnum;
  oauthRepositoryFullName: Scalars['String']['input'];
  oauthRepositoryId: Scalars['String']['input'];
};

/** Autogenerated return type of AssetCreateOauth. */
export type IAssetCreateOauthPayload = {
  __typename?: 'AssetCreateOauthPayload';
  assets?: Maybe<Array<IAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IAssetPage = {
  __typename?: 'AssetPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAsset>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IAssetPolicy = {
  __typename?: 'AssetPolicy';
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssetRemove */
export type IAssetRemoveInput = {
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssetRemove. */
export type IAssetRemovePayload = {
  __typename?: 'AssetRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow: ISoftwareEscrowInterface;
  success: Scalars['Boolean']['output'];
};

export type IAssetReport = {
  __typename?: 'AssetReport';
  asset: IAsset;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data: IReportData;
  id: Scalars['ID']['output'];
  period: Scalars['ISO8601Date']['output'];
};

export type IAssetReportGroup = {
  __typename?: 'AssetReportGroup';
  asset: IAsset;
  assetReports: Array<IAssetReport>;
  id: Scalars['ID']['output'];
  lastGenerated: Scalars['ISO8601Date']['output'];
};

export type IAssetReportGroupPage = {
  __typename?: 'AssetReportGroupPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAssetReportGroup>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum AssetTypeEnum {
  CustomRepo = 'custom_repo',
  OauthRepo = 'oauth_repo',
  RepoUpload = 'repo_upload',
  SecureUpload = 'secure_upload',
}

export enum AssetsOrderByEnum {
  AssetType = 'asset_type',
  CreatedAt = 'created_at',
  DepositMethod = 'deposit_method',
  DepositSource = 'deposit_source',
  DepositStatus = 'deposit_status',
  LastUpdateCheck = 'last_update_check',
  LatestDeposit = 'latest_deposit',
  SyncStatus = 'sync_status',
  UpdatedAt = 'updated_at',
}

/** Autogenerated input type of AssetsUpdate */
export type IAssetsUpdateInput = {
  assetIds: Array<Scalars['ID']['input']>;
  assetParams: IAssetsUpdateParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type IAssetsUpdateParams = {
  contentType?: InputMaybe<AssetContentTypeEnum>;
};

/** Autogenerated return type of AssetsUpdate. */
export type IAssetsUpdatePayload = {
  __typename?: 'AssetsUpdatePayload';
  assets: Array<IAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IAuditLog = {
  __typename?: 'AuditLog';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  parentType: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  recordId: Scalars['ID']['output'];
  recordType: Scalars['String']['output'];
  source: AuditLogSourceEnum;
  user?: Maybe<IUser>;
};

export type IAuditLogPage = {
  __typename?: 'AuditLogPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IAuditLog>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum AuditLogSourceEnum {
  Codekeeper = 'codekeeper',
  Counterparty = 'counterparty',
  System = 'system',
  User = 'user',
}

export type IBackup = IAppProtectionInterface & {
  __typename?: 'Backup';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  app: IApp;
  backupActivity: Scalars['JSON']['output'];
  certificationValidated: Scalars['Boolean']['output'];
  certificationVerified: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  description?: Maybe<Scalars['String']['output']>;
  disruptionNotification: DisruptionNotificationEnum;
  disruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
  id: Scalars['ID']['output'];
  lastBackup?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  pendingActivation: Scalars['Boolean']['output'];
  policy: IBackupPolicy;
  productType: AppProductTypeEnum;
  reportsEnabled: Scalars['Boolean']['output'];
  reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  requiredContentTypes: Array<ContentTypeEnum>;
  status: BackupStatusEnum;
  storageRegion: Scalars['String']['output'];
  taskCounts: Array<ITaskCount>;
  terminatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userUpdatedAt: Scalars['ISO8601DateTime']['output'];
  versionsLimit?: Maybe<Scalars['Int']['output']>;
};

export type IBackupAsset = {
  __typename?: 'BackupAsset';
  contentType?: Maybe<AssetContentTypeEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration?: Maybe<IIntegrationInterface>;
  lastBackup?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastBackupVersionId?: Maybe<Scalars['ID']['output']>;
  lastUpdateCheck?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  policy: IBackupAssetPolicy;
  size?: Maybe<Scalars['BigInt']['output']>;
  status: BackupAssetStatusEnum;
  syncStatus?: Maybe<SyncStatusEnum>;
  type: BackupAssetTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BackupAssetCreateCustom */
export type IBackupAssetCreateCustomInput = {
  backupAssetsParams: Array<IAssetCreateCustomParams>;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of BackupAssetCreateCustom. */
export type IBackupAssetCreateCustomPayload = {
  __typename?: 'BackupAssetCreateCustomPayload';
  backupAssets?: Maybe<Array<IBackupAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupAssetCreateOauth */
export type IBackupAssetCreateOauthInput = {
  backupAssetsParams: Array<IAssetCreateOauthParams>;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of BackupAssetCreateOauth. */
export type IBackupAssetCreateOauthPayload = {
  __typename?: 'BackupAssetCreateOauthPayload';
  backupAssets?: Maybe<Array<IBackupAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IBackupAssetPage = {
  __typename?: 'BackupAssetPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IBackupAsset>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IBackupAssetPolicy = {
  __typename?: 'BackupAssetPolicy';
  download: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type IBackupAssetReport = {
  __typename?: 'BackupAssetReport';
  backupAsset: IBackupAsset;
  createdAt: Scalars['ISO8601DateTime']['output'];
  data: IReportData;
  id: Scalars['ID']['output'];
  period: Scalars['ISO8601Date']['output'];
};

export type IBackupAssetReportGroup = {
  __typename?: 'BackupAssetReportGroup';
  backupAsset: IBackupAsset;
  backupAssetReports: Array<IBackupAssetReport>;
  id: Scalars['ID']['output'];
  lastGenerated: Scalars['ISO8601Date']['output'];
};

export type IBackupAssetReportGroupPage = {
  __typename?: 'BackupAssetReportGroupPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IBackupAssetReportGroup>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum BackupAssetStatusEnum {
  Awaiting = 'awaiting',
  Error = 'error',
  NoConfiguration = 'no_configuration',
  Taken = 'taken',
}

export enum BackupAssetTypeEnum {
  CustomRepo = 'custom_repo',
  OauthRepo = 'oauth_repo',
  RepoUpload = 'repo_upload',
  SecureUpload = 'secure_upload',
}

export enum BackupAssetsOrderByEnum {
  AssetType = 'asset_type',
  ContentType = 'content_type',
  CreatedAt = 'created_at',
  LastBackup = 'last_backup',
  LastUpdateCheck = 'last_update_check',
  Name = 'name',
  Status = 'status',
  UpdatedAt = 'updated_at',
}

/** Autogenerated input type of BackupAssetsUpdate */
export type IBackupAssetsUpdateInput = {
  assetParams: IAssetsUpdateParams;
  backupAssetIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BackupAssetsUpdate. */
export type IBackupAssetsUpdatePayload = {
  __typename?: 'BackupAssetsUpdatePayload';
  backupAssets: Array<IBackupAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IBackupCreateInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  disruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  disruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
  name: Scalars['String']['input'];
  requiredContentTypes?: InputMaybe<Array<ContentTypeEnum>>;
  storageRegion?: InputMaybe<Scalars['String']['input']>;
  versionsLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type IBackupCredential = {
  __typename?: 'BackupCredential';
  createdAt: Scalars['ISO8601DateTime']['output'];
  credentialType: CredentialTypeEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  policy: IBackupCredentialPolicy;
  providerName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IBackupCredentialCreateParams = {
  credentialType: CredentialTypeEnum;
  credentials: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
};

export type IBackupCredentialPage = {
  __typename?: 'BackupCredentialPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IBackupCredential>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IBackupCredentialPolicy = {
  __typename?: 'BackupCredentialPolicy';
  download: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupCredentialsCreate */
export type IBackupCredentialsCreateInput = {
  backupCredentialCreateParams: IBackupCredentialCreateParams;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BackupCredentialsCreate. */
export type IBackupCredentialsCreatePayload = {
  __typename?: 'BackupCredentialsCreatePayload';
  backupCredential?: Maybe<IBackupCredential>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum BackupCredentialsOrderByEnum {
  CreatedAt = 'created_at',
  CredentialType = 'credential_type',
  Name = 'name',
  ProviderName = 'provider_name',
  UpdatedAt = 'updated_at',
}

/** Autogenerated input type of BackupCredentialsRemove */
export type IBackupCredentialsRemoveInput = {
  backupCredentialId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BackupCredentialsRemove. */
export type IBackupCredentialsRemovePayload = {
  __typename?: 'BackupCredentialsRemovePayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IBackupPolicy = {
  __typename?: 'BackupPolicy';
  activate: Scalars['Boolean']['output'];
  backupAssets: Scalars['Boolean']['output'];
  deferActivation: Scalars['Boolean']['output'];
  enableReports: Scalars['Boolean']['output'];
  manageCredentials: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  setup: Scalars['Boolean']['output'];
  terminate: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  updateStorage: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupRepoUploadCancel */
export type IBackupRepoUploadCancelInput = {
  backupAssetId?: InputMaybe<Scalars['ID']['input']>;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of BackupRepoUploadCancel. */
export type IBackupRepoUploadCancelPayload = {
  __typename?: 'BackupRepoUploadCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupRepoUploadComplete */
export type IBackupRepoUploadCompleteInput = {
  backupAssetId?: InputMaybe<Scalars['ID']['input']>;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: AssetContentTypeEnum;
  parts: Array<ISecureUploadPartParams>;
  repoName?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['BigInt']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of BackupRepoUploadComplete. */
export type IBackupRepoUploadCompletePayload = {
  __typename?: 'BackupRepoUploadCompletePayload';
  backupAsset?: Maybe<IBackupAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupRepoUploadInit */
export type IBackupRepoUploadInitInput = {
  backupAssetId?: InputMaybe<Scalars['ID']['input']>;
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  numParts: Scalars['Int']['input'];
  repoName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BackupRepoUploadInit. */
export type IBackupRepoUploadInitPayload = {
  __typename?: 'BackupRepoUploadInitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type IBackupRepoUploadVerificationResult = {
  __typename?: 'BackupRepoUploadVerificationResult';
  /** The backup asset that was verified */
  backupAsset: IBackupAsset;
  /** Error message if verification failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the verification was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupSecureUploadCancel */
export type IBackupSecureUploadCancelInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of BackupSecureUploadCancel. */
export type IBackupSecureUploadCancelPayload = {
  __typename?: 'BackupSecureUploadCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupSecureUploadComplete */
export type IBackupSecureUploadCompleteInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: AssetContentTypeEnum;
  filename: Scalars['String']['input'];
  parts: Array<ISecureUploadPartParams>;
  size: Scalars['BigInt']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of BackupSecureUploadComplete. */
export type IBackupSecureUploadCompletePayload = {
  __typename?: 'BackupSecureUploadCompletePayload';
  backupAsset?: Maybe<IBackupAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BackupSecureUploadInit */
export type IBackupSecureUploadInitInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  numParts: Scalars['Int']['input'];
};

/** Autogenerated return type of BackupSecureUploadInit. */
export type IBackupSecureUploadInitPayload = {
  __typename?: 'BackupSecureUploadInitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum BackupStatusEnum {
  Active = 'active',
  Draft = 'draft',
  Setup = 'setup',
  Terminated = 'terminated',
}

export type IBackupStorageUpdateInput = {
  storageRegion?: InputMaybe<Scalars['String']['input']>;
  versionsLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type IBackupUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  disruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredContentTypes?: InputMaybe<Array<ContentTypeEnum>>;
};

export type IBackupVersion = {
  __typename?: 'BackupVersion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  status: BackupVersionStatusEnum;
};

export type IBackupVersionPage = {
  __typename?: 'BackupVersionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IBackupVersion>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum BackupVersionStatusEnum {
  Failed = 'failed',
  Finished = 'finished',
  Skipped = 'skipped',
}

export enum BeneficiariesOrderByEnum {
  CompanyName = 'company_name',
}

export type IBeneficiary = IEscrowPartyInterface & {
  __typename?: 'Beneficiary';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ICompany>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  contacts: Array<IContact>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  escrow: IEscrowInterface;
  id: Scalars['ID']['output'];
  isStatic: Scalars['Boolean']['output'];
  policy: IBeneficiaryPolicy;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IBeneficiaryChangeParams = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deletedContacts?: InputMaybe<Array<IDeleteContactChangeParams>>;
  editedContacts?: InputMaybe<Array<IEditContactChangeParams>>;
  newContacts?: InputMaybe<Array<IContactCreateParams>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of BeneficiaryCreate */
export type IBeneficiaryCreateInput = {
  beneficiaryParams: IEscrowPartyParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of BeneficiaryCreate. */
export type IBeneficiaryCreatePayload = {
  __typename?: 'BeneficiaryCreatePayload';
  beneficiary?: Maybe<IBeneficiary>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IBeneficiaryPage = {
  __typename?: 'BeneficiaryPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IBeneficiary>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IBeneficiaryPolicy = {
  __typename?: 'BeneficiaryPolicy';
  createEscrowMemberships: Scalars['Boolean']['output'];
  readEscrowMemberships: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BeneficiaryUpdate */
export type IBeneficiaryUpdateInput = {
  beneficiaryId: Scalars['ID']['input'];
  beneficiaryParams: IEscrowPartyParams;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BeneficiaryUpdate. */
export type IBeneficiaryUpdatePayload = {
  __typename?: 'BeneficiaryUpdatePayload';
  beneficiary: IBeneficiary;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IBilling = {
  __typename?: 'Billing';
  billingAddress?: Maybe<IBillingAddress>;
  paymentMethod?: Maybe<IPaymentMethod>;
  policy: IBillingPolicy;
  subscriptions?: Maybe<Array<IBillingSubscription>>;
};

export type IBillingAddress = {
  __typename?: 'BillingAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type IBillingAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  companyRegistrationNumber: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type IBillingPolicy = {
  __typename?: 'BillingPolicy';
  applyCoupon: Scalars['Boolean']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  requestCancellation: Scalars['Boolean']['output'];
  requestExclusiveOffer: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export type IBillingSubscription = {
  __typename?: 'BillingSubscription';
  addons: Array<IAddon>;
  billingPeriod: Scalars['Int']['output'];
  billingPeriodUnit: Scalars['String']['output'];
  coupons?: Maybe<Array<Scalars['String']['output']>>;
  currencyCode: Scalars['String']['output'];
  nextBillingAt?: Maybe<Scalars['ISO8601Date']['output']>;
  plans: Array<IPlan>;
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of CancelSubscription */
export type ICancelSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelSubscription. */
export type ICancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: ICompany;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IClientChangesRequested = {
  __typename?: 'ClientChangesRequested';
  creator: Scalars['String']['output'];
  id: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  receiver: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IClientChangesRequestedPayload = {
  __typename?: 'ClientChangesRequestedPayload';
  agreement?: Maybe<IClientChangesRequested>;
  beneficiary?: Maybe<IClientChangesRequested>;
  depositor?: Maybe<IClientChangesRequested>;
  deposits?: Maybe<IClientChangesRequested>;
  environment?: Maybe<IClientChangesRequested>;
  isRequested: Scalars['Boolean']['output'];
  notifications?: Maybe<IClientChangesRequested>;
};

export type ICompany = {
  __typename?: 'Company';
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistration?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationStatus: CompanyInvitationStatusEnum;
  policy: ICompanyPolicy;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  ssoEnabled: Scalars['Boolean']['output'];
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  subscriptionCancellationRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subscriptionExclusiveCouponAppliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ICompanyInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyRegistration?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyInvitationStatusEnum {
  Completed = 'completed',
  Pending = 'pending',
}

export type ICompanyPolicy = {
  __typename?: 'CompanyPolicy';
  createIntegration: Scalars['Boolean']['output'];
  createUser: Scalars['Boolean']['output'];
  readAuditLog: Scalars['Boolean']['output'];
  readBilling: Scalars['Boolean']['output'];
  readIntegrations: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConfirmEmailChange */
export type IConfirmEmailChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmEmailChange. */
export type IConfirmEmailChangePayload = {
  __typename?: 'ConfirmEmailChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContact = {
  __typename?: 'Contact';
  contactType: ContactTypeEnum;
  email: Scalars['String']['output'];
  escrow: IEscrowInterface;
  escrowParty: IEscrowPartyInterface;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  signatory: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactCreate */
export type IContactCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactParams: IContactCreateParams;
  escrowPartyId: Scalars['ID']['input'];
};

export type IContactCreateParams = {
  contactType: ContactTypeEnum;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  signatory: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ContactCreate. */
export type IContactCreatePayload = {
  __typename?: 'ContactCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<IContact>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactRemove */
export type IContactRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactRemove. */
export type IContactRemovePayload = {
  __typename?: 'ContactRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow?: Maybe<IEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export enum ContactTypeEnum {
  Administrative = 'administrative',
  AllTypes = 'all_types',
  Legal = 'legal',
  Technical = 'technical',
}

/** Autogenerated input type of ContactUpdate */
export type IContactUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  contactParams: IContactUpdateParams;
};

export type IContactUpdateParams = {
  contactType?: InputMaybe<ContactTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signatory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ContactUpdate. */
export type IContactUpdatePayload = {
  __typename?: 'ContactUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<IContact>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum ContentTypeEnum {
  Credentials = 'credentials',
  Data = 'data',
  Deployment = 'deployment',
  Documentation = 'documentation',
  SourceCode = 'source_code',
  ThirdPartyDependency = 'third_party_dependency',
}

export type IContinuityEscrow = IAppProtectionInterface &
  IEscrowInterface & {
    __typename?: 'ContinuityEscrow';
    activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    activationNotification: Scalars['Boolean']['output'];
    adminReviewAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    agreement: IAgreement;
    agreementSettingsConfigured: Scalars['Boolean']['output'];
    app: IApp;
    beneficiary?: Maybe<IBeneficiary>;
    beneficiaryActivityNotification: ActivityNotificationEnum;
    beneficiaryConfigured: Scalars['Boolean']['output'];
    beneficiaryDisruptionNotification: DisruptionNotificationEnum;
    beneficiaryDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    beneficiarySharedInformation: Scalars['Boolean']['output'];
    certificationCertified: Scalars['Boolean']['output'];
    certificationValidated: Scalars['Boolean']['output'];
    certificationVerified: Scalars['Boolean']['output'];
    changesRequested: Scalars['Boolean']['output'];
    createdAt: Scalars['ISO8601DateTime']['output'];
    currentCompanyRole?: Maybe<EscrowPartyTypeEnum>;
    depositor?: Maybe<IDepositor>;
    depositorActivityNotification: ActivityNotificationEnum;
    depositorConfigured: Scalars['Boolean']['output'];
    depositorDisruptionNotification: DisruptionNotificationEnum;
    depositorDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    escrowInvitation?: Maybe<IEscrowInvitation>;
    escrowTermination?: Maybe<IEscrowTermination>;
    events: Array<IEscrowEvent>;
    hostingProviders: Array<IContinuityProvider>;
    id: Scalars['ID']['output'];
    lastProvider?: Maybe<Scalars['ISO8601DateTime']['output']>;
    legalStatus: Array<ILegalStatus>;
    onboardingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    pendingActivation: Scalars['Boolean']['output'];
    policy: IContinuityEscrowPolicy;
    productType: AppProductTypeEnum;
    reportsEnabled: Scalars['Boolean']['output'];
    reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    requiredContentTypes: Array<ContinuityProviderRoleEnum>;
    signatures: Array<ISignature>;
    signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    startedBy: EscrowPartyTypeEnum;
    status: EscrowStatusEnum;
    taskCounts: Array<ITaskCount>;
    thirdPartyProviders: Array<IContinuityProvider>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    userUpdatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** Autogenerated input type of ContinuityEscrowActivate */
export type IContinuityEscrowActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContinuityEscrowActivate. */
export type IContinuityEscrowActivatePayload = {
  __typename?: 'ContinuityEscrowActivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityEscrow?: Maybe<IContinuityEscrow>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContinuityEscrowCreate */
export type IContinuityEscrowCreateInput = {
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityEscrowCreateParams: IEscrowCreateParams;
};

/** Autogenerated return type of ContinuityEscrowCreate. */
export type IContinuityEscrowCreatePayload = {
  __typename?: 'ContinuityEscrowCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityEscrow?: Maybe<IContinuityEscrow>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContinuityEscrowEnableReports */
export type IContinuityEscrowEnableReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContinuityEscrowEnableReports. */
export type IContinuityEscrowEnableReportsPayload = {
  __typename?: 'ContinuityEscrowEnableReportsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityEscrow?: Maybe<IContinuityEscrow>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContinuityEscrowPolicy = {
  __typename?: 'ContinuityEscrowPolicy';
  activate: Scalars['Boolean']['output'];
  createAgreementSuggestedChange: Scalars['Boolean']['output'];
  createBeneficiary: Scalars['Boolean']['output'];
  createBeneficiarySuggestedChange: Scalars['Boolean']['output'];
  createDepositorSuggestedChange: Scalars['Boolean']['output'];
  createEnvironmentSuggestedChange: Scalars['Boolean']['output'];
  createNotificationSuggestedChange: Scalars['Boolean']['output'];
  createProviders: Scalars['Boolean']['output'];
  deferActivation: Scalars['Boolean']['output'];
  enableReports: Scalars['Boolean']['output'];
  inviteBeneficiary: Scalars['Boolean']['output'];
  inviteDepositor: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  requestTermination: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  updateBeneficiaryNotifications: Scalars['Boolean']['output'];
  updateDepositorNotifications: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContinuityEscrowUpdateContentTypes */
export type IContinuityEscrowUpdateContentTypesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityEscrowId: Scalars['ID']['input'];
  requiredContentTypes: Array<ContinuityProviderRoleEnum>;
};

/** Autogenerated return type of ContinuityEscrowUpdateContentTypes. */
export type IContinuityEscrowUpdateContentTypesPayload = {
  __typename?: 'ContinuityEscrowUpdateContentTypesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityEscrow?: Maybe<IContinuityEscrow>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContinuityProvider = {
  __typename?: 'ContinuityProvider';
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contactEmail: Scalars['String']['output'];
  continuityEscrow: IContinuityEscrow;
  costModel: ContinuityProviderCostModelEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  monthlyCost: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
  policy: IContinuityProviderPolicy;
  role: ContinuityProviderRoleEnum;
  status: ContinuityProviderStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ContinuityProviderConfirm */
export type IContinuityProviderConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityProviderId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContinuityProviderConfirm. */
export type IContinuityProviderConfirmPayload = {
  __typename?: 'ContinuityProviderConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityProvider?: Maybe<IContinuityProvider>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum ContinuityProviderCostModelEnum {
  Fixed = 'fixed',
  PayAsYouUse = 'pay_as_you_use',
}

/** Autogenerated input type of ContinuityProviderCreate */
export type IContinuityProviderCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityEscrowId: Scalars['ID']['input'];
  continuityProviderParams: IContinuityProviderCreateParams;
};

export type IContinuityProviderCreateParams = {
  contactEmail: Scalars['String']['input'];
  costModel: ContinuityProviderCostModelEnum;
  description: Scalars['String']['input'];
  monthlyCost: Scalars['Float']['input'];
  platform: Scalars['String']['input'];
  role: ContinuityProviderRoleEnum;
};

/** Autogenerated return type of ContinuityProviderCreate. */
export type IContinuityProviderCreatePayload = {
  __typename?: 'ContinuityProviderCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityProvider?: Maybe<IContinuityProvider>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContinuityProviderDeletedParams = {
  id: Scalars['String']['input'];
};

export type IContinuityProviderEditedParams = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  costModel?: InputMaybe<ContinuityProviderCostModelEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  monthlyCost?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};

export type IContinuityProviderPolicy = {
  __typename?: 'ContinuityProviderPolicy';
  confirm: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContinuityProviderRemove */
export type IContinuityProviderRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityProviderId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContinuityProviderRemove. */
export type IContinuityProviderRemovePayload = {
  __typename?: 'ContinuityProviderRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum ContinuityProviderRoleEnum {
  Hosting = 'hosting',
  ThirdParty = 'third_party',
}

export enum ContinuityProviderStatusEnum {
  AccessIssues = 'access_issues',
  Confirmed = 'confirmed',
  PendingVerification = 'pending_verification',
  Unconfirmed = 'unconfirmed',
}

/** Autogenerated input type of ContinuityProviderUpdate */
export type IContinuityProviderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  continuityProviderId: Scalars['ID']['input'];
  continuityProviderParams: IContinuityProviderUpdateParams;
};

export type IContinuityProviderUpdateParams = {
  contactEmail: Scalars['String']['input'];
  costModel: ContinuityProviderCostModelEnum;
  description: Scalars['String']['input'];
  monthlyCost: Scalars['Float']['input'];
  role: ContinuityProviderRoleEnum;
};

/** Autogenerated return type of ContinuityProviderUpdate. */
export type IContinuityProviderUpdatePayload = {
  __typename?: 'ContinuityProviderUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  continuityProvider?: Maybe<IContinuityProvider>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContinuityReport = {
  __typename?: 'ContinuityReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  hostingProviders: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issues: Scalars['Int']['output'];
  providers: Array<IContinuityReportProvider>;
  result: ContinuityReportResultsEnum;
  thirdPartyProviders: Scalars['Int']['output'];
  totalProviders: Scalars['Int']['output'];
};

export type IContinuityReportPage = {
  __typename?: 'ContinuityReportPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IContinuityReport>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IContinuityReportProvider = {
  __typename?: 'ContinuityReportProvider';
  platform: Scalars['String']['output'];
  result: ContinuityReportResultsEnum;
  role: ContinuityProviderRoleEnum;
};

export enum ContinuityReportResultsEnum {
  AccessConfirmed = 'access_confirmed',
  AccessIssues = 'access_issues',
}

/** Autogenerated input type of CreateBackup */
export type ICreateBackupInput = {
  appId: Scalars['ID']['input'];
  backupParams: IBackupCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBackup. */
export type ICreateBackupPayload = {
  __typename?: 'CreateBackupPayload';
  backup?: Maybe<IBackup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCustodianOperation */
export type ICreateCustodianOperationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianOperationParams: ICustodianOperationCreateInput;
  custodianProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCustodianOperation. */
export type ICreateCustodianOperationPayload = {
  __typename?: 'CreateCustodianOperationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianOperation?: Maybe<ICustodianOperation>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCustodianProfile */
export type ICreateCustodianProfileInput = {
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCustodianProfile. */
export type ICreateCustodianProfilePayload = {
  __typename?: 'CreateCustodianProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianProfile?: Maybe<ICustodianProfile>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCustomIntegration */
export type ICreateCustomIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customIntegrationInput: ICustomIntegrationInputAttributes;
};

/** Autogenerated return type of CreateCustomIntegration. */
export type ICreateCustomIntegrationPayload = {
  __typename?: 'CreateCustomIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customIntegration?: Maybe<ICustomIntegration>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFeedback */
export type ICreateFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFeedback. */
export type ICreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateShareFileIntegration */
export type ICreateShareFileIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shareFileIntegrationInput: IShareFileIntegrationInputAttributes;
};

/** Autogenerated return type of CreateShareFileIntegration. */
export type ICreateShareFileIntegrationPayload = {
  __typename?: 'CreateShareFileIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shareFileIntegration?: Maybe<IShareFileIntegration>;
  success: Scalars['Boolean']['output'];
};

export enum CredentialTypeEnum {
  ApiCredentials = 'api_credentials',
  CryptographicKey = 'cryptographic_key',
  Login = 'login',
}

export type ICustodianAsset = {
  __typename?: 'CustodianAsset';
  createdAt: Scalars['ISO8601DateTime']['output'];
  custodianIntegration: ICustodianIntegration;
  custodianProfile: ICustodianProfile;
  custodianStatus: CustodianAssetCustodianStatusEnum;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationalStatus: CustodianAssetOperationalStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ICustodianAssetCreateInput = {
  oauthRepositoryId: Scalars['String']['input'];
  operationalStatus: CustodianAssetOperationalStatusEnum;
};

export enum CustodianAssetCustodianStatusEnum {
  Pending = 'pending',
  Secured = 'secured',
}

export enum CustodianAssetOperationalStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
}

export type ICustodianIntegration = {
  __typename?: 'CustodianIntegration';
  createdAt: Scalars['ISO8601DateTime']['output'];
  custodianAssets: Array<ICustodianAsset>;
  custodianProfile: ICustodianProfile;
  id: Scalars['ID']['output'];
  integration: IOauthIntegration;
  status: CustodianIntegrationStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CustodianIntegrationStatusEnum {
  Pending = 'pending',
  SetupCompleted = 'setup_completed',
}

export type ICustodianOperation = {
  __typename?: 'CustodianOperation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  custodianProfile: ICustodianProfile;
  custodianServiceEvents: Array<CustodianOperationCustodianServiceEventEnum>;
  custodianServiceEventsCustom?: Maybe<Scalars['String']['output']>;
  dataRetention?: Maybe<Scalars['Int']['output']>;
  endOfRetentionPeriod: CustodianOperationEndOfRetentionPeriodEnum;
  endOfRetentionPeriodCustom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  operationType: CustodianOperationTypeEnum;
  operationTypeCustom?: Maybe<Scalars['String']['output']>;
  regulatoryRequirements: Array<CustodianOperationRegulatoryRequirementsEnum>;
  regulatoryRequirementsCustom?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ICustodianOperationCreateInput = {
  custodianServiceEvents: Array<CustodianOperationCustodianServiceEventEnum>;
  custodianServiceEventsCustom?: InputMaybe<Scalars['String']['input']>;
  dataRetention?: InputMaybe<Scalars['Int']['input']>;
  endOfRetentionPeriod: CustodianOperationEndOfRetentionPeriodEnum;
  endOfRetentionPeriodCustom?: InputMaybe<Scalars['String']['input']>;
  operationType: CustodianOperationTypeEnum;
  operationTypeCustom?: InputMaybe<Scalars['String']['input']>;
  regulatoryRequirements: Array<CustodianOperationRegulatoryRequirementsEnum>;
  regulatoryRequirementsCustom?: InputMaybe<Scalars['String']['input']>;
};

export enum CustodianOperationCustodianServiceEventEnum {
  Bankrupcy = 'bankrupcy',
  Custom = 'custom',
  Insolvency = 'insolvency',
  MaintenanceObligationsNotMet = 'maintenance_obligations_not_met',
}

export enum CustodianOperationEndOfRetentionPeriodEnum {
  Archive = 'archive',
  Custom = 'custom',
  Delete = 'delete',
  Relabel = 'relabel',
}

export enum CustodianOperationRegulatoryRequirementsEnum {
  App = 'app',
  Ccpa = 'ccpa',
  Custom = 'custom',
  Gdpr = 'gdpr',
  Hippa = 'hippa',
}

export enum CustodianOperationTypeEnum {
  Custom = 'custom',
  Finance = 'finance',
  Health = 'health',
  Kyc = 'kyc',
  Privacy = 'privacy',
  Regulatory = 'regulatory',
  Security = 'security',
  ServiceAgreement = 'service_agreement',
}

export type ICustodianOperationUpdateInput = {
  custodianServiceEvents: Array<CustodianOperationCustodianServiceEventEnum>;
  custodianServiceEventsCustom?: InputMaybe<Scalars['String']['input']>;
  dataRetention?: InputMaybe<Scalars['Int']['input']>;
  endOfRetentionPeriod: CustodianOperationEndOfRetentionPeriodEnum;
  endOfRetentionPeriodCustom?: InputMaybe<Scalars['String']['input']>;
  operationTypeCustom?: InputMaybe<Scalars['String']['input']>;
  regulatoryRequirements: Array<CustodianOperationRegulatoryRequirementsEnum>;
  regulatoryRequirementsCustom?: InputMaybe<Scalars['String']['input']>;
};

export type ICustodianProfile = IAppProtectionInterface & {
  __typename?: 'CustodianProfile';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  app: IApp;
  certificationValidated: Scalars['Boolean']['output'];
  company: ICompany;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  custodianAssets: Array<ICustodianAsset>;
  custodianIntegrations: Array<ICustodianIntegration>;
  custodianOperations: Array<ICustodianOperation>;
  custodianTermination?: Maybe<ICustodianTermination>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  policy: ICustodianProfilePolicy;
  productType: AppProductTypeEnum;
  status: CustodianProfileStatusEnum;
  taskCounts: Array<ITaskCount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ICustodianProfilePolicy = {
  __typename?: 'CustodianProfilePolicy';
  activate: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  requestTermination: Scalars['Boolean']['output'];
  submitForReview: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export enum CustodianProfileStatusEnum {
  AccessSetup = 'access_setup',
  Active = 'active',
  Draft = 'draft',
  Terminated = 'terminated',
}

export type ICustodianTermination = {
  __typename?: 'CustodianTermination';
  createdAt: Scalars['ISO8601DateTime']['output'];
  custodianProfile: ICustodianProfile;
  id: Scalars['ID']['output'];
  requesterUser: IUser;
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: CustodianTerminationStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CustodianTerminationStatusEnum {
  Accepted = 'accepted',
  Finished = 'finished',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type ICustomIntegration = IIntegrationInterface & {
  __typename?: 'CustomIntegration';
  accountName?: Maybe<Scalars['String']['output']>;
  accountUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  id: Scalars['ID']['output'];
  isClientOwner?: Maybe<Scalars['Boolean']['output']>;
  membersCount: Scalars['Int']['output'];
  owner?: Maybe<IUser>;
  policy: IIntegrationPolicy;
  provider: Scalars['String']['output'];
  status: IntegrationStatusEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ICustomIntegrationInputAttributes = {
  accountName: Scalars['String']['input'];
  accountUrl?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider: CustomIntegrationProviderEnum;
  region?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomIntegrationProviderEnum {
  Aws = 'aws',
  AzureDevops = 'azure_devops',
  Beanstalk = 'beanstalk',
  Bitbucket = 'bitbucket',
  BitbucketServer = 'bitbucket_server',
  Codecommit = 'codecommit',
  Gcp = 'gcp',
  Github = 'github',
  GithubServer = 'github_server',
  Gitlab = 'gitlab',
  GitlabServer = 'gitlab_server',
  Svn = 'svn',
}

export type ICustomIntegrationUpdateInputAttributes = {
  accountName: Scalars['String']['input'];
  accountUrl?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type IDeleteContactChangeParams = {
  id: Scalars['String']['input'];
};

export type IDeletedAssetParams = {
  id: Scalars['String']['input'];
};

export type IDeletedSaasCredentialParams = {
  id: Scalars['String']['input'];
};

export type IDepositChangeParams = {
  deletedAssets?: InputMaybe<Array<IDeletedAssetParams>>;
  deletedSaasCredentials?: InputMaybe<Array<IDeletedSaasCredentialParams>>;
};

export enum DepositMethodEnum {
  Automatic = 'automatic',
  Manual = 'manual',
}

export enum DepositStatusEnum {
  Awaiting = 'awaiting',
  Error = 'error',
  NoConfiguration = 'no_configuration',
  Taken = 'taken',
}

export type IDepositor = IEscrowPartyInterface & {
  __typename?: 'Depositor';
  city?: Maybe<Scalars['String']['output']>;
  company: ICompany;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  contacts: Array<IContact>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  escrow: IEscrowInterface;
  id: Scalars['ID']['output'];
  policy: IDepositorPolicy;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IDepositorChangeParams = {
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deletedContacts?: InputMaybe<Array<IDeleteContactChangeParams>>;
  editedContacts?: InputMaybe<Array<IEditContactChangeParams>>;
  newContacts?: InputMaybe<Array<IContactCreateParams>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IDepositorPolicy = {
  __typename?: 'DepositorPolicy';
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DepositorUpdate */
export type IDepositorUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  depositorId: Scalars['ID']['input'];
  depositorParams: IEscrowPartyParams;
};

/** Autogenerated return type of DepositorUpdate. */
export type IDepositorUpdatePayload = {
  __typename?: 'DepositorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  depositor: IDepositor;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum DisruptionNotificationEnum {
  NoNotifications = 'no_notifications',
  SendNotification = 'send_notification',
}

export enum DisruptionNotificationGracePeriodEnum {
  Immediate = 'immediate',
  SevenDays = 'seven_days',
  ThirtyDays = 'thirty_days',
  TwentyFourHours = 'twenty_four_hours',
}

export type IEditContactChangeParams = {
  contactType?: InputMaybe<ContactTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signatory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of Edit */
export type IEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  userInput: IEditUserInput;
};

/** Autogenerated return type of Edit. */
export type IEditPayload = {
  __typename?: 'EditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<IUser>;
};

export type IEditUserInput = {
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
};

/** Autogenerated input type of EnableBackupReports */
export type IEnableBackupReportsInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EnableBackupReports. */
export type IEnableBackupReportsPayload = {
  __typename?: 'EnableBackupReportsPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IEnvironmentChangeParams = {
  deletedProviders?: InputMaybe<Array<IContinuityProviderDeletedParams>>;
  editedProviders?: InputMaybe<Array<IContinuityProviderEditedParams>>;
};

export type IEscrowCreateParams = {
  agreementForm: AgreementFormEnum;
};

export type IEscrowEvent = IEventInterface & {
  __typename?: 'EscrowEvent';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: Scalars['String']['output'];
  payload: IEscrowInterface;
};

export type IEscrowInterface = {
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  activationNotification: Scalars['Boolean']['output'];
  adminReviewAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  agreement: IAgreement;
  agreementSettingsConfigured: Scalars['Boolean']['output'];
  app: IApp;
  beneficiary?: Maybe<IBeneficiary>;
  beneficiaryActivityNotification: ActivityNotificationEnum;
  beneficiaryConfigured: Scalars['Boolean']['output'];
  beneficiaryDisruptionNotification: DisruptionNotificationEnum;
  beneficiaryDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
  beneficiarySharedInformation: Scalars['Boolean']['output'];
  certificationCertified: Scalars['Boolean']['output'];
  certificationValidated: Scalars['Boolean']['output'];
  certificationVerified: Scalars['Boolean']['output'];
  changesRequested: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentCompanyRole?: Maybe<EscrowPartyTypeEnum>;
  depositor?: Maybe<IDepositor>;
  depositorActivityNotification: ActivityNotificationEnum;
  depositorConfigured: Scalars['Boolean']['output'];
  depositorDisruptionNotification: DisruptionNotificationEnum;
  depositorDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
  escrowInvitation?: Maybe<IEscrowInvitation>;
  escrowTermination?: Maybe<IEscrowTermination>;
  events: Array<IEscrowEvent>;
  id: Scalars['ID']['output'];
  legalStatus: Array<ILegalStatus>;
  onboardingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pendingActivation: Scalars['Boolean']['output'];
  productType: AppProductTypeEnum;
  reportsEnabled: Scalars['Boolean']['output'];
  reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  signatures: Array<ISignature>;
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startedBy: EscrowPartyTypeEnum;
  status: EscrowStatusEnum;
  taskCounts: Array<ITaskCount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userUpdatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IEscrowInvitation = {
  __typename?: 'EscrowInvitation';
  appName: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  escrow: IEscrowInterface;
  id: Scalars['ID']['output'];
  partyType: Scalars['String']['output'];
  policy: IEscrowInvitationPolicy;
  status: InvitationStatusEnum;
  user?: Maybe<IUser>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EscrowInvitationAccept */
export type IEscrowInvitationAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowInvitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowInvitationAccept. */
export type IEscrowInvitationAcceptPayload = {
  __typename?: 'EscrowInvitationAcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowInvitation: IEscrowInvitation;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowInvitationCreate */
export type IEscrowInvitationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  escrowInvitationParams: IEscrowInvitationCreateParams;
};

export type IEscrowInvitationCreateParams = {
  companyName: Scalars['String']['input'];
  partyType: EscrowPartyTypeEnum;
  userEmail: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

/** Autogenerated return type of EscrowInvitationCreate. */
export type IEscrowInvitationCreatePayload = {
  __typename?: 'EscrowInvitationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowInvitation?: Maybe<IEscrowInvitation>;
  success: Scalars['Boolean']['output'];
};

export type IEscrowInvitationPage = {
  __typename?: 'EscrowInvitationPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IEscrowInvitation>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IEscrowInvitationPolicy = {
  __typename?: 'EscrowInvitationPolicy';
  accept: Scalars['Boolean']['output'];
  reject: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowInvitationReject */
export type IEscrowInvitationRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowInvitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowInvitationReject. */
export type IEscrowInvitationRejectPayload = {
  __typename?: 'EscrowInvitationRejectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowInvitation: IEscrowInvitation;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowInvitationUpdate */
export type IEscrowInvitationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowInvitationId: Scalars['ID']['input'];
  escrowInvitationParams: IEscrowInvitationUpdateParams;
};

export type IEscrowInvitationUpdateParams = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EscrowInvitationUpdate. */
export type IEscrowInvitationUpdatePayload = {
  __typename?: 'EscrowInvitationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowInvitation: IEscrowInvitation;
  success: Scalars['Boolean']['output'];
};

export type IEscrowMembership = {
  __typename?: 'EscrowMembership';
  appSubscription: IAppSubscription;
  beneficiary: IBeneficiary;
  id: Scalars['ID']['output'];
  policy: IEscrowMembershipPolicy;
  role: EscrowMembershipRoleEnum;
};

/** Autogenerated input type of EscrowMembershipCreate */
export type IEscrowMembershipCreateInput = {
  beneficiaryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowMembershipParams: IEscrowMembershipParams;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowMembershipCreate. */
export type IEscrowMembershipCreatePayload = {
  __typename?: 'EscrowMembershipCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowMembership?: Maybe<IEscrowMembership>;
  success: Scalars['Boolean']['output'];
};

export type IEscrowMembershipPage = {
  __typename?: 'EscrowMembershipPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IEscrowMembership>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IEscrowMembershipParams = {
  role: EscrowMembershipRoleEnum;
};

export type IEscrowMembershipPolicy = {
  __typename?: 'EscrowMembershipPolicy';
  remove: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowMembershipRemove */
export type IEscrowMembershipRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowMembershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowMembershipRemove. */
export type IEscrowMembershipRemovePayload = {
  __typename?: 'EscrowMembershipRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum EscrowMembershipRoleEnum {
  Legal = 'legal',
  Manager = 'manager',
  Technical = 'technical',
  Viewer = 'viewer',
}

/** Autogenerated input type of EscrowMembershipUpdate */
export type IEscrowMembershipUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowMembershipId: Scalars['ID']['input'];
  escrowMembershipParams: IEscrowMembershipParams;
};

/** Autogenerated return type of EscrowMembershipUpdate. */
export type IEscrowMembershipUpdatePayload = {
  __typename?: 'EscrowMembershipUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowMembership?: Maybe<IEscrowMembership>;
  success: Scalars['Boolean']['output'];
};

export enum EscrowMembershipsOrderByEnum {
  Email = 'email',
  Name = 'name',
  Role = 'role',
}

export type IEscrowPartyInterface = {
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  contacts: Array<IContact>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  escrow: IEscrowInterface;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IEscrowPartyParams = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum EscrowPartyTypeEnum {
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
}

/** Autogenerated input type of EscrowRemove */
export type IEscrowRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowRemove. */
export type IEscrowRemovePayload = {
  __typename?: 'EscrowRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowRequestCertifiedAddon */
export type IEscrowRequestCertifiedAddonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EscrowRequestCertifiedAddon. */
export type IEscrowRequestCertifiedAddonPayload = {
  __typename?: 'EscrowRequestCertifiedAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow: IEscrowInterface;
  success: Scalars['Boolean']['output'];
};

export enum EscrowStatusEnum {
  Active = 'active',
  AdminReview = 'admin_review',
  Draft = 'draft',
  Error = 'error',
  Onboarding = 'onboarding',
  PendingTermination = 'pending_termination',
  Signed = 'signed',
  Terminated = 'terminated',
}

export type IEscrowTermination = {
  __typename?: 'EscrowTermination';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  adminReviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  escrow: IEscrowInterface;
  id: Scalars['ID']['output'];
  noticePeriod: Scalars['Int']['output'];
  policy: IEscrowTerminationPolicy;
  requestedAt: Scalars['ISO8601DateTime']['output'];
  requesterParty: EscrowPartyTypeEnum;
  requesterUser?: Maybe<IUser>;
  status: EscrowTerminationStatusEnum;
  terminateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of EscrowTerminationAccept */
export type IEscrowTerminationAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowTerminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowTerminationAccept. */
export type IEscrowTerminationAcceptPayload = {
  __typename?: 'EscrowTerminationAcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowTermination: IEscrowTermination;
  success: Scalars['Boolean']['output'];
};

export type IEscrowTerminationPolicy = {
  __typename?: 'EscrowTerminationPolicy';
  accept: Scalars['Boolean']['output'];
  reject: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowTerminationReject */
export type IEscrowTerminationRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowTerminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowTerminationReject. */
export type IEscrowTerminationRejectPayload = {
  __typename?: 'EscrowTerminationRejectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowTermination: IEscrowTermination;
  success: Scalars['Boolean']['output'];
};

export enum EscrowTerminationStatusEnum {
  Accepted = 'accepted',
  AdminAccepted = 'admin_accepted',
  AdminDeclined = 'admin_declined',
  Finished = 'finished',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Autogenerated input type of EscrowTerminationTerminate */
export type IEscrowTerminationTerminateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of EscrowTerminationTerminate. */
export type IEscrowTerminationTerminatePayload = {
  __typename?: 'EscrowTerminationTerminatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrowTermination?: Maybe<IEscrowTermination>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowUpdateBeneficiaryNotifications */
export type IEscrowUpdateBeneficiaryNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  escrowParams: IEscrowUpdateBeneficiaryNotificationsParams;
};

export type IEscrowUpdateBeneficiaryNotificationsParams = {
  beneficiaryActivityNotification?: InputMaybe<ActivityNotificationEnum>;
  beneficiaryDisruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  beneficiaryDisruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
};

/** Autogenerated return type of EscrowUpdateBeneficiaryNotifications. */
export type IEscrowUpdateBeneficiaryNotificationsPayload = {
  __typename?: 'EscrowUpdateBeneficiaryNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow: IEscrowInterface;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowUpdateDepositorNotifications */
export type IEscrowUpdateDepositorNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  escrowParams: IEscrowUpdateDepositorNotificationsParams;
};

export type IEscrowUpdateDepositorNotificationsParams = {
  depositorActivityNotification?: InputMaybe<ActivityNotificationEnum>;
  depositorDisruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  depositorDisruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
};

/** Autogenerated return type of EscrowUpdateDepositorNotifications. */
export type IEscrowUpdateDepositorNotificationsPayload = {
  __typename?: 'EscrowUpdateDepositorNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow: IEscrowInterface;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EscrowUpdate */
export type IEscrowUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  escrowParams: IEscrowUpdateParams;
};

export type IEscrowUpdateParams = {
  activationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  beneficiarySharedInformation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EscrowUpdate. */
export type IEscrowUpdatePayload = {
  __typename?: 'EscrowUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  escrow: IEscrowInterface;
  success: Scalars['Boolean']['output'];
};

export type IEventInterface = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: Scalars['String']['output'];
};

/** Autogenerated input type of FinishAuth */
export type IFinishAuthInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientPayload: IIntegrationAuthClientPayloadInput;
  options?: InputMaybe<IIntegrationAuthOptionsInput>;
  provider: OauthIntegrationProviderEnum;
  stateToken: Scalars['String']['input'];
};

/** Autogenerated return type of FinishAuth. */
export type IFinishAuthPayload = {
  __typename?: 'FinishAuthPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  oauthIntegration?: Maybe<IOauthIntegration>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of Impersonate */
export type IImpersonateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of Impersonate. */
export type IImpersonatePayload = {
  __typename?: 'ImpersonatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InitAuth */
export type IInitAuthInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<IIntegrationAuthOptionsInput>;
  provider: OauthIntegrationProviderEnum;
};

/** Autogenerated return type of InitAuth. */
export type IInitAuthPayload = {
  __typename?: 'InitAuthPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  integrationAuth?: Maybe<IIntegrationAuth>;
  success: Scalars['Boolean']['output'];
};

export type IIntegrationAuth = {
  __typename?: 'IntegrationAuth';
  stateToken: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IIntegrationAuthClientPayloadInput = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type IIntegrationAuthOptionsInput = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type IIntegrationInterface = {
  accountName?: Maybe<Scalars['String']['output']>;
  accountUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  id: Scalars['ID']['output'];
  membersCount: Scalars['Int']['output'];
  owner?: Maybe<IUser>;
  policy: IIntegrationPolicy;
  provider: Scalars['String']['output'];
  status: IntegrationStatusEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IIntegrationInterfacePage = {
  __typename?: 'IntegrationInterfacePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IIntegrationInterface>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IIntegrationMember = {
  __typename?: 'IntegrationMember';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  integration: IIntegrationInterface;
  role: IntegrationMemberRoleEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: IUser;
};

/** Autogenerated input type of IntegrationMemberCreate */
export type IIntegrationMemberCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of IntegrationMemberCreate. */
export type IIntegrationMemberCreatePayload = {
  __typename?: 'IntegrationMemberCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  integrationMember?: Maybe<IIntegrationMember>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of IntegrationMemberRemove */
export type IIntegrationMemberRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of IntegrationMemberRemove. */
export type IIntegrationMemberRemovePayload = {
  __typename?: 'IntegrationMemberRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum IntegrationMemberRoleEnum {
  Administrator = 'administrator',
  Owner = 'owner',
}

export type IIntegrationPolicy = {
  __typename?: 'IntegrationPolicy';
  createMember: Scalars['Boolean']['output'];
  depositAssets: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export enum IntegrationProviderEnum {
  Aws = 'aws',
  Azure = 'azure',
  AzureDevops = 'azure_devops',
  AzureDevopsLegacy = 'azure_devops_legacy',
  Beanstalk = 'beanstalk',
  Bitbucket = 'bitbucket',
  BitbucketServer = 'bitbucket_server',
  Codecommit = 'codecommit',
  Gcp = 'gcp',
  Github = 'github',
  GithubServer = 'github_server',
  Gitlab = 'gitlab',
  GitlabServer = 'gitlab_server',
  ShareFileFtps = 'share_file_ftps',
  ShareFileHttps = 'share_file_https',
  Svn = 'svn',
}

export enum IntegrationStatusEnum {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Pending = 'pending',
}

export enum IntegrationTypeEnum {
  Custom = 'custom',
  Oauth = 'oauth',
  ShareFile = 'share_file',
}

export enum InvitationStatusEnum {
  Accepted = 'accepted',
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type IInvoice = {
  __typename?: 'Invoice';
  currencyCode: Scalars['String']['output'];
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatusEnum;
  total: Scalars['Int']['output'];
};

export type IInvoicePage = {
  __typename?: 'InvoicePage';
  nextOffset?: Maybe<Scalars['String']['output']>;
  nodes: Array<IInvoice>;
};

export type IInvoicePdf = {
  __typename?: 'InvoicePdf';
  downloadUrl: Scalars['String']['output'];
};

export enum InvoiceStatusEnum {
  NotPaid = 'not_paid',
  Paid = 'paid',
  PaymentDue = 'payment_due',
  Pending = 'pending',
  Posted = 'posted',
  Voided = 'voided',
}

export enum JurisdictionEnum {
  BeneficiaryJurisdiction = 'beneficiary_jurisdiction',
  DepositorJurisdiction = 'depositor_jurisdiction',
  EscrowAgentJurisdiction = 'escrow_agent_jurisdiction',
}

export type ILegacyRepo = {
  __typename?: 'LegacyRepo';
  id: Scalars['ID']['output'];
  migrationStatus: LegacyRepoMigrationStatusEnum;
  platform: LegacyRepoPlatformEnum;
  softwareEscrow: ISoftwareEscrow;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum LegacyRepoMigrationStatusEnum {
  Awaiting = 'awaiting',
  Migrated = 'migrated',
}

export type ILegacyRepoPage = {
  __typename?: 'LegacyRepoPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ILegacyRepo>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum LegacyRepoPlatformEnum {
  Assembla = 'assembla',
  AwsCodecommit = 'aws_codecommit',
  AzureDevops = 'azure_devops',
  Bitbucket = 'bitbucket',
  Gcp = 'gcp',
  Github = 'github',
  Gitlab = 'gitlab',
  GitlabServer = 'gitlab_server',
  S3 = 's3',
  SecureUploadFolder = 'secure_upload_folder',
  Sourceforge = 'sourceforge',
  Subvision = 'subvision',
}

export enum LegacyReposOrderByEnum {
  MigrationStatus = 'migration_status',
  Platform = 'platform',
  Title = 'title',
  Url = 'url',
}

export enum LegalContextEnum {
  Development = 'development',
  License = 'license',
  Other = 'other',
  Saas = 'saas',
  Transaction = 'transaction',
}

export type ILegalStatus = {
  __typename?: 'LegalStatus';
  role: Scalars['String']['output'];
  signed?: Maybe<Scalars['Boolean']['output']>;
};

export enum LiabilityEnum {
  Total_0 = 'total_0',
  Total_29 = 'total_29',
  Total_89 = 'total_89',
  Total_149 = 'total_149',
}

/** Autogenerated input type of MarkAsRead */
export type IMarkAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkAsRead. */
export type IMarkAsReadPayload = {
  __typename?: 'MarkAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  tasks: Array<ITask>;
};

/** Autogenerated input type of MarkAsUnread */
export type IMarkAsUnreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkAsUnread. */
export type IMarkAsUnreadPayload = {
  __typename?: 'MarkAsUnreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  tasks: Array<ITask>;
};

/** Autogenerated input type of MigrateLegacyRepo */
export type IMigrateLegacyRepoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  legacyRepoId: Scalars['ID']['input'];
  oauthRepoId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MigrateLegacyRepo. */
export type IMigrateLegacyRepoPayload = {
  __typename?: 'MigrateLegacyRepoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MigrateLegacyRepos */
export type IMigrateLegacyReposInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  legacyRepoIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MigrateLegacyRepos. */
export type IMigrateLegacyReposPayload = {
  __typename?: 'MigrateLegacyReposPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  migratedLegacyRepos: Array<ILegacyRepo>;
  success: Scalars['Boolean']['output'];
};

export type IMutation = {
  __typename?: 'Mutation';
  activateBackup?: Maybe<IActivateBackupPayload>;
  addUser?: Maybe<IAddPayload>;
  agreementApprove?: Maybe<IAgreementApprovePayload>;
  agreementGenerate?: Maybe<IAgreementGeneratePayload>;
  agreementUpdate?: Maybe<IAgreementUpdatePayload>;
  appCreate?: Maybe<IAppCreatePayload>;
  appLinkProducts?: Maybe<IAppLinkProductsPayload>;
  appLogoDirectUpload?: Maybe<IAppLogoDirectUploadPayload>;
  appMembershipRemove?: Maybe<IAppMembershipRemovePayload>;
  appMembershipUpdate?: Maybe<IAppMembershipUpdatePayload>;
  appMembershipsCreate?: Maybe<IAppMembershipsCreatePayload>;
  appRemove?: Maybe<IAppRemovePayload>;
  appRequestAccept?: Maybe<IAppRequestAcceptPayload>;
  appRequestCreate?: Maybe<IAppRequestCreatePayload>;
  appRequestDecline?: Maybe<IAppRequestDeclinePayload>;
  appUpdate?: Maybe<IAppUpdatePayload>;
  applyCoupon?: Maybe<IApplyCouponPayload>;
  assetCreateCustom?: Maybe<IAssetCreateCustomPayload>;
  assetCreateOauth?: Maybe<IAssetCreateOauthPayload>;
  assetRemove?: Maybe<IAssetRemovePayload>;
  assetsUpdate?: Maybe<IAssetsUpdatePayload>;
  backupAssetsUpdate?: Maybe<IBackupAssetsUpdatePayload>;
  backupCredentialsCreate?: Maybe<IBackupCredentialsCreatePayload>;
  backupCredentialsRemove?: Maybe<IBackupCredentialsRemovePayload>;
  backupRepoUploadCancel?: Maybe<IBackupRepoUploadCancelPayload>;
  backupRepoUploadComplete?: Maybe<IBackupRepoUploadCompletePayload>;
  backupRepoUploadInit?: Maybe<IBackupRepoUploadInitPayload>;
  backupSecureUploadCancel?: Maybe<IBackupSecureUploadCancelPayload>;
  backupSecureUploadComplete?: Maybe<IBackupSecureUploadCompletePayload>;
  backupSecureUploadInit?: Maybe<IBackupSecureUploadInitPayload>;
  beneficiaryCreate?: Maybe<IBeneficiaryCreatePayload>;
  beneficiaryUpdate?: Maybe<IBeneficiaryUpdatePayload>;
  cancelSubscription?: Maybe<ICancelSubscriptionPayload>;
  confirmEmailChange?: Maybe<IConfirmEmailChangePayload>;
  contactCreate?: Maybe<IContactCreatePayload>;
  contactRemove?: Maybe<IContactRemovePayload>;
  contactUpdate?: Maybe<IContactUpdatePayload>;
  continuityEscrowActivate?: Maybe<IContinuityEscrowActivatePayload>;
  continuityEscrowCreate?: Maybe<IContinuityEscrowCreatePayload>;
  continuityEscrowEnableReports?: Maybe<IContinuityEscrowEnableReportsPayload>;
  continuityEscrowUpdateContentTypes?: Maybe<IContinuityEscrowUpdateContentTypesPayload>;
  continuityProviderConfirm?: Maybe<IContinuityProviderConfirmPayload>;
  continuityProviderCreate?: Maybe<IContinuityProviderCreatePayload>;
  continuityProviderRemove?: Maybe<IContinuityProviderRemovePayload>;
  continuityProviderUpdate?: Maybe<IContinuityProviderUpdatePayload>;
  createBackup?: Maybe<ICreateBackupPayload>;
  createCustodianOperation?: Maybe<ICreateCustodianOperationPayload>;
  createCustodianProfile?: Maybe<ICreateCustodianProfilePayload>;
  createCustomBackupAssets?: Maybe<IBackupAssetCreateCustomPayload>;
  createCustomIntegration?: Maybe<ICreateCustomIntegrationPayload>;
  createFeedback?: Maybe<ICreateFeedbackPayload>;
  createOauthBackupAssets?: Maybe<IBackupAssetCreateOauthPayload>;
  createShareFileIntegration?: Maybe<ICreateShareFileIntegrationPayload>;
  depositorUpdate?: Maybe<IDepositorUpdatePayload>;
  editUser?: Maybe<IEditPayload>;
  enableBackupReports?: Maybe<IEnableBackupReportsPayload>;
  escrowInvitationAccept?: Maybe<IEscrowInvitationAcceptPayload>;
  escrowInvitationCreate?: Maybe<IEscrowInvitationCreatePayload>;
  escrowInvitationReject?: Maybe<IEscrowInvitationRejectPayload>;
  escrowInvitationUpdate?: Maybe<IEscrowInvitationUpdatePayload>;
  escrowMembershipCreate?: Maybe<IEscrowMembershipCreatePayload>;
  escrowMembershipRemove?: Maybe<IEscrowMembershipRemovePayload>;
  escrowMembershipUpdate?: Maybe<IEscrowMembershipUpdatePayload>;
  escrowRemove?: Maybe<IEscrowRemovePayload>;
  escrowRequestCertifiedAddon?: Maybe<IEscrowRequestCertifiedAddonPayload>;
  escrowTerminationAccept?: Maybe<IEscrowTerminationAcceptPayload>;
  escrowTerminationReject?: Maybe<IEscrowTerminationRejectPayload>;
  escrowTerminationRequest?: Maybe<IEscrowTerminationTerminatePayload>;
  escrowUpdate?: Maybe<IEscrowUpdatePayload>;
  escrowUpdateBeneficiaryNotifications?: Maybe<IEscrowUpdateBeneficiaryNotificationsPayload>;
  escrowUpdateDepositorNotifications?: Maybe<IEscrowUpdateDepositorNotificationsPayload>;
  finishOauthIntegrationAuth?: Maybe<IFinishAuthPayload>;
  impersonateUser?: Maybe<IImpersonatePayload>;
  initOauthIntegrationAuth?: Maybe<IInitAuthPayload>;
  integrationMemberCreate?: Maybe<IIntegrationMemberCreatePayload>;
  integrationMemberRemove?: Maybe<IIntegrationMemberRemovePayload>;
  markAsReadTasks?: Maybe<IMarkAsReadPayload>;
  markAsUnreadTasks?: Maybe<IMarkAsUnreadPayload>;
  migrateLegacyRepo?: Maybe<IMigrateLegacyRepoPayload>;
  migrateLegacyRepos?: Maybe<IMigrateLegacyReposPayload>;
  reinitOauthIntegrationAuth?: Maybe<IReinitAuthPayload>;
  removeBackup?: Maybe<IRemoveBackupPayload>;
  removeBackupAsset?: Maybe<IRemoveBackupAssetPayload>;
  removeCustodianOperation?: Maybe<IRemoveCustodianOperationPayload>;
  removeCustodianProfile?: Maybe<IRemoveCustodianProfilePayload>;
  removeUser?: Maybe<IRemovePayload>;
  repoUploadCancel?: Maybe<IRepoUploadCancelPayload>;
  repoUploadComplete?: Maybe<IRepoUploadCompletePayload>;
  repoUploadInit?: Maybe<IRepoUploadInitPayload>;
  requestBackupCredentialDownload?: Maybe<IRequestBackupCredentialDownloadPayload>;
  requestBackupSecureUploadDownload?: Maybe<IRequestBackupSecureUploadDownloadPayload>;
  requestBackupVersionDownload?: Maybe<IRequestBackupVersionDownloadPayload>;
  requestExclusiveOffer?: Maybe<IRequestExclusiveOfferPayload>;
  saasCredentialsCreate?: Maybe<ISaasCredentialsCreatePayload>;
  saasCredentialsRemove?: Maybe<ISaasCredentialsRemovePayload>;
  saasEscrowCreate?: Maybe<ISaasEscrowCreatePayload>;
  secureUploadCancel?: Maybe<ISecureUploadCancelPayload>;
  secureUploadComplete?: Maybe<ISecureUploadCompletePayload>;
  secureUploadInit?: Maybe<ISecureUploadInitPayload>;
  sendForReviewCustodianProfile?: Maybe<ISendForReviewCustodianProfilePayload>;
  setupBackup?: Maybe<ISetupBackupPayload>;
  softwareEscrowActivate?: Maybe<ISoftwareEscrowActivatePayload>;
  softwareEscrowCreate?: Maybe<ISoftwareEscrowCreatePayload>;
  softwareEscrowEnableReports?: Maybe<ISoftwareEscrowEnableReportsPayload>;
  softwareEscrowUpdate?: Maybe<ISoftwareEscrowUpdatePayload>;
  softwareEscrowUpdateContentTypes?: Maybe<ISoftwareEscrowUpdateContentTypesPayload>;
  suggestedChangeCreate?: Maybe<ISuggestedChangeCreatePayload>;
  suggestedChangeReview?: Maybe<ISuggestedChangeReviewPayload>;
  suggestedChangeUpdate?: Maybe<ISuggestedChangeUpdatePayload>;
  terminateBackup?: Maybe<ITerminateBackupPayload>;
  terminateCustodianProfile?: Maybe<ITerminateCustodianProfilePayload>;
  toggleIntegration?: Maybe<ITogglePayload>;
  transferCompanyOwnership?: Maybe<ITransferCompanyOwnershipPayload>;
  updateBackup?: Maybe<IUpdateBackupPayload>;
  updateBackupStorage?: Maybe<IUpdateBackupStoragePayload>;
  updateBillingAddress?: Maybe<IUpdateBillingAddressPayload>;
  updateCompany?: Maybe<IUpdateCompanyPayload>;
  updateCustodianAssets?: Maybe<IUpdateCustodianAssetsPayload>;
  updateCustodianOperation?: Maybe<IUpdateCustodianOperationPayload>;
  updateCustomIntegration?: Maybe<IUpdateCustomIntegrationPayload>;
  updatePaymentMethod?: Maybe<IRequestUpdatePaymentPagePayload>;
  updateProfileInfo?: Maybe<IUpdateProfileInfoPayload>;
};

export type IMutationActivateBackupArgs = {
  input: IActivateBackupInput;
};

export type IMutationAddUserArgs = {
  input: IAddInput;
};

export type IMutationAgreementApproveArgs = {
  input: IAgreementApproveInput;
};

export type IMutationAgreementGenerateArgs = {
  input: IAgreementGenerateInput;
};

export type IMutationAgreementUpdateArgs = {
  input: IAgreementUpdateInput;
};

export type IMutationAppCreateArgs = {
  input: IAppCreateInput;
};

export type IMutationAppLinkProductsArgs = {
  input: IAppLinkProductsInput;
};

export type IMutationAppLogoDirectUploadArgs = {
  input: IAppLogoDirectUploadInput;
};

export type IMutationAppMembershipRemoveArgs = {
  input: IAppMembershipRemoveInput;
};

export type IMutationAppMembershipUpdateArgs = {
  input: IAppMembershipUpdateInput;
};

export type IMutationAppMembershipsCreateArgs = {
  input: IAppMembershipsCreateInput;
};

export type IMutationAppRemoveArgs = {
  input: IAppRemoveInput;
};

export type IMutationAppRequestAcceptArgs = {
  input: IAppRequestAcceptInput;
};

export type IMutationAppRequestCreateArgs = {
  input: IAppRequestCreateInput;
};

export type IMutationAppRequestDeclineArgs = {
  input: IAppRequestDeclineInput;
};

export type IMutationAppUpdateArgs = {
  input: IAppUpdateInput;
};

export type IMutationApplyCouponArgs = {
  input: IApplyCouponInput;
};

export type IMutationAssetCreateCustomArgs = {
  input: IAssetCreateCustomInput;
};

export type IMutationAssetCreateOauthArgs = {
  input: IAssetCreateOauthInput;
};

export type IMutationAssetRemoveArgs = {
  input: IAssetRemoveInput;
};

export type IMutationAssetsUpdateArgs = {
  input: IAssetsUpdateInput;
};

export type IMutationBackupAssetsUpdateArgs = {
  input: IBackupAssetsUpdateInput;
};

export type IMutationBackupCredentialsCreateArgs = {
  input: IBackupCredentialsCreateInput;
};

export type IMutationBackupCredentialsRemoveArgs = {
  input: IBackupCredentialsRemoveInput;
};

export type IMutationBackupRepoUploadCancelArgs = {
  input: IBackupRepoUploadCancelInput;
};

export type IMutationBackupRepoUploadCompleteArgs = {
  input: IBackupRepoUploadCompleteInput;
};

export type IMutationBackupRepoUploadInitArgs = {
  input: IBackupRepoUploadInitInput;
};

export type IMutationBackupSecureUploadCancelArgs = {
  input: IBackupSecureUploadCancelInput;
};

export type IMutationBackupSecureUploadCompleteArgs = {
  input: IBackupSecureUploadCompleteInput;
};

export type IMutationBackupSecureUploadInitArgs = {
  input: IBackupSecureUploadInitInput;
};

export type IMutationBeneficiaryCreateArgs = {
  input: IBeneficiaryCreateInput;
};

export type IMutationBeneficiaryUpdateArgs = {
  input: IBeneficiaryUpdateInput;
};

export type IMutationCancelSubscriptionArgs = {
  input: ICancelSubscriptionInput;
};

export type IMutationConfirmEmailChangeArgs = {
  input: IConfirmEmailChangeInput;
};

export type IMutationContactCreateArgs = {
  input: IContactCreateInput;
};

export type IMutationContactRemoveArgs = {
  input: IContactRemoveInput;
};

export type IMutationContactUpdateArgs = {
  input: IContactUpdateInput;
};

export type IMutationContinuityEscrowActivateArgs = {
  input: IContinuityEscrowActivateInput;
};

export type IMutationContinuityEscrowCreateArgs = {
  input: IContinuityEscrowCreateInput;
};

export type IMutationContinuityEscrowEnableReportsArgs = {
  input: IContinuityEscrowEnableReportsInput;
};

export type IMutationContinuityEscrowUpdateContentTypesArgs = {
  input: IContinuityEscrowUpdateContentTypesInput;
};

export type IMutationContinuityProviderConfirmArgs = {
  input: IContinuityProviderConfirmInput;
};

export type IMutationContinuityProviderCreateArgs = {
  input: IContinuityProviderCreateInput;
};

export type IMutationContinuityProviderRemoveArgs = {
  input: IContinuityProviderRemoveInput;
};

export type IMutationContinuityProviderUpdateArgs = {
  input: IContinuityProviderUpdateInput;
};

export type IMutationCreateBackupArgs = {
  input: ICreateBackupInput;
};

export type IMutationCreateCustodianOperationArgs = {
  input: ICreateCustodianOperationInput;
};

export type IMutationCreateCustodianProfileArgs = {
  input: ICreateCustodianProfileInput;
};

export type IMutationCreateCustomBackupAssetsArgs = {
  input: IBackupAssetCreateCustomInput;
};

export type IMutationCreateCustomIntegrationArgs = {
  input: ICreateCustomIntegrationInput;
};

export type IMutationCreateFeedbackArgs = {
  input: ICreateFeedbackInput;
};

export type IMutationCreateOauthBackupAssetsArgs = {
  input: IBackupAssetCreateOauthInput;
};

export type IMutationCreateShareFileIntegrationArgs = {
  input: ICreateShareFileIntegrationInput;
};

export type IMutationDepositorUpdateArgs = {
  input: IDepositorUpdateInput;
};

export type IMutationEditUserArgs = {
  input: IEditInput;
};

export type IMutationEnableBackupReportsArgs = {
  input: IEnableBackupReportsInput;
};

export type IMutationEscrowInvitationAcceptArgs = {
  input: IEscrowInvitationAcceptInput;
};

export type IMutationEscrowInvitationCreateArgs = {
  input: IEscrowInvitationCreateInput;
};

export type IMutationEscrowInvitationRejectArgs = {
  input: IEscrowInvitationRejectInput;
};

export type IMutationEscrowInvitationUpdateArgs = {
  input: IEscrowInvitationUpdateInput;
};

export type IMutationEscrowMembershipCreateArgs = {
  input: IEscrowMembershipCreateInput;
};

export type IMutationEscrowMembershipRemoveArgs = {
  input: IEscrowMembershipRemoveInput;
};

export type IMutationEscrowMembershipUpdateArgs = {
  input: IEscrowMembershipUpdateInput;
};

export type IMutationEscrowRemoveArgs = {
  input: IEscrowRemoveInput;
};

export type IMutationEscrowRequestCertifiedAddonArgs = {
  input: IEscrowRequestCertifiedAddonInput;
};

export type IMutationEscrowTerminationAcceptArgs = {
  input: IEscrowTerminationAcceptInput;
};

export type IMutationEscrowTerminationRejectArgs = {
  input: IEscrowTerminationRejectInput;
};

export type IMutationEscrowTerminationRequestArgs = {
  input: IEscrowTerminationTerminateInput;
};

export type IMutationEscrowUpdateArgs = {
  input: IEscrowUpdateInput;
};

export type IMutationEscrowUpdateBeneficiaryNotificationsArgs = {
  input: IEscrowUpdateBeneficiaryNotificationsInput;
};

export type IMutationEscrowUpdateDepositorNotificationsArgs = {
  input: IEscrowUpdateDepositorNotificationsInput;
};

export type IMutationFinishOauthIntegrationAuthArgs = {
  input: IFinishAuthInput;
};

export type IMutationImpersonateUserArgs = {
  input: IImpersonateInput;
};

export type IMutationInitOauthIntegrationAuthArgs = {
  input: IInitAuthInput;
};

export type IMutationIntegrationMemberCreateArgs = {
  input: IIntegrationMemberCreateInput;
};

export type IMutationIntegrationMemberRemoveArgs = {
  input: IIntegrationMemberRemoveInput;
};

export type IMutationMarkAsReadTasksArgs = {
  input: IMarkAsReadInput;
};

export type IMutationMarkAsUnreadTasksArgs = {
  input: IMarkAsUnreadInput;
};

export type IMutationMigrateLegacyRepoArgs = {
  input: IMigrateLegacyRepoInput;
};

export type IMutationMigrateLegacyReposArgs = {
  input: IMigrateLegacyReposInput;
};

export type IMutationReinitOauthIntegrationAuthArgs = {
  input: IReinitAuthInput;
};

export type IMutationRemoveBackupArgs = {
  input: IRemoveBackupInput;
};

export type IMutationRemoveBackupAssetArgs = {
  input: IRemoveBackupAssetInput;
};

export type IMutationRemoveCustodianOperationArgs = {
  input: IRemoveCustodianOperationInput;
};

export type IMutationRemoveCustodianProfileArgs = {
  input: IRemoveCustodianProfileInput;
};

export type IMutationRemoveUserArgs = {
  input: IRemoveInput;
};

export type IMutationRepoUploadCancelArgs = {
  input: IRepoUploadCancelInput;
};

export type IMutationRepoUploadCompleteArgs = {
  input: IRepoUploadCompleteInput;
};

export type IMutationRepoUploadInitArgs = {
  input: IRepoUploadInitInput;
};

export type IMutationRequestBackupCredentialDownloadArgs = {
  input: IRequestBackupCredentialDownloadInput;
};

export type IMutationRequestBackupSecureUploadDownloadArgs = {
  input: IRequestBackupSecureUploadDownloadInput;
};

export type IMutationRequestBackupVersionDownloadArgs = {
  input: IRequestBackupVersionDownloadInput;
};

export type IMutationRequestExclusiveOfferArgs = {
  input: IRequestExclusiveOfferInput;
};

export type IMutationSaasCredentialsCreateArgs = {
  input: ISaasCredentialsCreateInput;
};

export type IMutationSaasCredentialsRemoveArgs = {
  input: ISaasCredentialsRemoveInput;
};

export type IMutationSaasEscrowCreateArgs = {
  input: ISaasEscrowCreateInput;
};

export type IMutationSecureUploadCancelArgs = {
  input: ISecureUploadCancelInput;
};

export type IMutationSecureUploadCompleteArgs = {
  input: ISecureUploadCompleteInput;
};

export type IMutationSecureUploadInitArgs = {
  input: ISecureUploadInitInput;
};

export type IMutationSendForReviewCustodianProfileArgs = {
  input: ISendForReviewCustodianProfileInput;
};

export type IMutationSetupBackupArgs = {
  input: ISetupBackupInput;
};

export type IMutationSoftwareEscrowActivateArgs = {
  input: ISoftwareEscrowActivateInput;
};

export type IMutationSoftwareEscrowCreateArgs = {
  input: ISoftwareEscrowCreateInput;
};

export type IMutationSoftwareEscrowEnableReportsArgs = {
  input: ISoftwareEscrowEnableReportsInput;
};

export type IMutationSoftwareEscrowUpdateArgs = {
  input: ISoftwareEscrowUpdateInput;
};

export type IMutationSoftwareEscrowUpdateContentTypesArgs = {
  input: ISoftwareEscrowUpdateContentTypesInput;
};

export type IMutationSuggestedChangeCreateArgs = {
  input: ISuggestedChangeCreateInput;
};

export type IMutationSuggestedChangeReviewArgs = {
  input: ISuggestedChangeReviewInput;
};

export type IMutationSuggestedChangeUpdateArgs = {
  input: ISuggestedChangeUpdateInput;
};

export type IMutationTerminateBackupArgs = {
  input: ITerminateBackupInput;
};

export type IMutationTerminateCustodianProfileArgs = {
  input: ITerminateCustodianProfileInput;
};

export type IMutationToggleIntegrationArgs = {
  input: IToggleInput;
};

export type IMutationTransferCompanyOwnershipArgs = {
  input: ITransferCompanyOwnershipInput;
};

export type IMutationUpdateBackupArgs = {
  input: IUpdateBackupInput;
};

export type IMutationUpdateBackupStorageArgs = {
  input: IUpdateBackupStorageInput;
};

export type IMutationUpdateBillingAddressArgs = {
  input: IUpdateBillingAddressInput;
};

export type IMutationUpdateCompanyArgs = {
  input: IUpdateCompanyInput;
};

export type IMutationUpdateCustodianAssetsArgs = {
  input: IUpdateCustodianAssetsInput;
};

export type IMutationUpdateCustodianOperationArgs = {
  input: IUpdateCustodianOperationInput;
};

export type IMutationUpdateCustomIntegrationArgs = {
  input: IUpdateCustomIntegrationInput;
};

export type IMutationUpdatePaymentMethodArgs = {
  input: IRequestUpdatePaymentPageInput;
};

export type IMutationUpdateProfileInfoArgs = {
  input: IUpdateProfileInfoInput;
};

export type INotificationChangeParams = {
  activationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  assetVersionsLimit?: InputMaybe<Scalars['Int']['input']>;
  beneficiaryActivityNotification?: InputMaybe<ActivityNotificationEnum>;
  beneficiaryDisruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  beneficiaryDisruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
  beneficiarySharedInformation?: InputMaybe<Scalars['Boolean']['input']>;
  depositorActivityNotification?: InputMaybe<ActivityNotificationEnum>;
  depositorDisruptionNotification?: InputMaybe<DisruptionNotificationEnum>;
  depositorDisruptionNotificationGracePeriod?: InputMaybe<DisruptionNotificationGracePeriodEnum>;
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};

export type IOauthIntegration = IIntegrationInterface & {
  __typename?: 'OauthIntegration';
  accountName?: Maybe<Scalars['String']['output']>;
  accountUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  id: Scalars['ID']['output'];
  isClientOwner?: Maybe<Scalars['Boolean']['output']>;
  membersCount: Scalars['Int']['output'];
  owner?: Maybe<IUser>;
  policy: IIntegrationPolicy;
  provider: Scalars['String']['output'];
  status: IntegrationStatusEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum OauthIntegrationProviderEnum {
  Azure = 'azure',
  AzureDevops = 'azure_devops',
  AzureDevopsLegacy = 'azure_devops_legacy',
  Bitbucket = 'bitbucket',
  Gcp = 'gcp',
  Github = 'github',
  Gitlab = 'gitlab',
}

export type IOauthReposConn = {
  __typename?: 'OauthReposConn';
  repositories: Array<IOauthRepository>;
  success: Scalars['Boolean']['output'];
};

export type IOauthRepository = {
  __typename?: 'OauthRepository';
  description?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: RepositoryTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export type IPaymentMethod = {
  __typename?: 'PaymentMethod';
  cardLast4?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IPlan = {
  __typename?: 'Plan';
  currencyCode: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  period: Scalars['Int']['output'];
  periodUnit: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type IProfile = {
  __typename?: 'Profile';
  email?: Maybe<Scalars['String']['output']>;
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoleEnum>;
};

export enum ProtectionPeriodEnum {
  M_3 = 'm_3',
  M_6 = 'm_6',
  M_12 = 'm_12',
}

export type IQuery = {
  __typename?: 'Query';
  /** Get escrow agreement */
  agreement?: Maybe<IAgreement>;
  /** A single app */
  app: IApp;
  appMemberships: IAppMembershipPage;
  /** Certification summary across the protections of every app */
  appProtectionAssuranceSummary: IAppProtectionAssuranceSummary;
  appProtections: Array<IAppProtectionInterface>;
  appRequests: IAppRequestPage;
  appSubscriptions: IAppSubscriptionPage;
  /** AI-estimated attributes of an application, based on its name */
  appSuggestion: IAppSuggestion;
  apps: IAppPage;
  assetReport?: Maybe<IAssetReport>;
  /** Asset report groups */
  assetReportGroups: IAssetReportGroupPage;
  assets: IAssetPage;
  auditLogs: IAuditLogPage;
  /** A single backup */
  backup: IBackup;
  backupAssetReport?: Maybe<IBackupAssetReport>;
  /** Backup asset report groups */
  backupAssetReportGroups: IBackupAssetReportGroupPage;
  backupAssets: IBackupAssetPage;
  /** Backup credentials */
  backupCredentials: IBackupCredentialPage;
  backupVersions: IBackupVersionPage;
  beneficiaries: IBeneficiaryPage;
  beneficiary: IBeneficiary;
  /** Beneficiary certificate asset count */
  beneficiaryCertificateAssetCount: IAssetCount;
  /** Beneficiary certificate saas credential count */
  beneficiaryCertificateSaasCredentialCount: ISaasCredentialCount;
  /** Billing information */
  billing?: Maybe<IBilling>;
  clientChangesRequested: IClientChangesRequestedPayload;
  company: ICompany;
  continuityEscrow: IContinuityEscrow;
  continuityReport: IContinuityReport;
  /** Continuity reports */
  continuityReports: IContinuityReportPage;
  custodianProfile?: Maybe<ICustodianProfile>;
  /** A single escrow invitation */
  escrowInvitation: IEscrowInvitation;
  escrowInvitations?: Maybe<IEscrowInvitationPage>;
  /** Escrow members */
  escrowMemberships: IEscrowMembershipPage;
  /** A single integration */
  integration: IIntegrationInterface;
  /** Integration members */
  integrationMembers: Array<IIntegrationMember>;
  integrations: IIntegrationInterfacePage;
  invoicePdf?: Maybe<IInvoicePdf>;
  invoices: IInvoicePage;
  /** Legacy repos ready for migration */
  legacyRepos: ILegacyRepoPage;
  /** Connection to the integration for OAuth repos */
  oauthReposConn: IOauthReposConn;
  profile: IProfile;
  /** Saas credentials */
  saasCredentials: ISaasCredentialPage;
  /** A single saas escrow */
  saasEscrow: ISaasEscrow;
  /** A single software escrow */
  softwareEscrow: ISoftwareEscrow;
  /** Escrow suggested changes */
  suggestedChanges: ISuggestChangePage;
  tasks: ITaskPage;
  users: IUserPage;
};

export type IQueryAgreementArgs = {
  escrowId: Scalars['ID']['input'];
};

export type IQueryAppArgs = {
  appId: Scalars['ID']['input'];
};

export type IQueryAppMembershipsArgs = {
  appId: Scalars['ID']['input'];
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AppMembershipsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryAppProtectionAssuranceSummaryArgs = {
  owned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryAppProtectionsArgs = {
  appId: Scalars['ID']['input'];
  certificationTypes?: InputMaybe<Array<AppCertificationTypeEnum>>;
  productTypes?: InputMaybe<Array<AppProductTypeEnum>>;
  statuses?: InputMaybe<Array<AppProtectionStatusEnum>>;
};

export type IQueryAppRequestsArgs = {
  kind: AppRequestsKindEnum;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryAppSubscriptionsArgs = {
  appId: Scalars['ID']['input'];
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AppSubscriptionsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryAppSuggestionArgs = {
  appName: Scalars['String']['input'];
};

export type IQueryAppsArgs = {
  certificationTypes?: InputMaybe<Array<AppCertificationTypeEnum>>;
  needsFinishing?: InputMaybe<Scalars['Boolean']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productTypes?: InputMaybe<Array<AppProductTypeEnum>>;
  productsExist?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
  unreadTasksExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryAssetReportArgs = {
  assetReportId: Scalars['ID']['input'];
  softwareEscrowId: Scalars['ID']['input'];
};

export type IQueryAssetReportGroupsArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AssetsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['ISO8601Date']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
};

export type IQueryAssetsArgs = {
  contentType?: InputMaybe<AssetContentTypeEnum>;
  depositStatus?: InputMaybe<DepositStatusEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  labeled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AssetsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
  syncStatuses?: InputMaybe<Array<SyncStatusEnum>>;
  type?: InputMaybe<AssetTypeEnum>;
};

export type IQueryAuditLogsArgs = {
  createdAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryBackupArgs = {
  backupId: Scalars['ID']['input'];
};

export type IQueryBackupAssetReportArgs = {
  backupAssetReportId: Scalars['ID']['input'];
  backupId: Scalars['ID']['input'];
};

export type IQueryBackupAssetReportGroupsArgs = {
  backupAssetId?: InputMaybe<Scalars['ID']['input']>;
  backupId: Scalars['ID']['input'];
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AssetsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type IQueryBackupAssetsArgs = {
  backupId: Scalars['ID']['input'];
  contentType?: InputMaybe<AssetContentTypeEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  labeled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<BackupAssetsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BackupAssetStatusEnum>;
  syncStatus?: InputMaybe<SyncStatusEnum>;
  type?: InputMaybe<BackupAssetTypeEnum>;
};

export type IQueryBackupCredentialsArgs = {
  backupId?: InputMaybe<Scalars['ID']['input']>;
  credentialType?: InputMaybe<CredentialTypeEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<BackupCredentialsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryBackupVersionsArgs = {
  backupAssetId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryBeneficiariesArgs = {
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<BeneficiariesOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryBeneficiaryArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryBeneficiaryCertificateAssetCountArgs = {
  contentType?: InputMaybe<AssetContentTypeEnum>;
  depositStatus?: InputMaybe<DepositStatusEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  labeled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<AssetsOrderByEnum>;
  queryFilter?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
  syncStatuses?: InputMaybe<Array<SyncStatusEnum>>;
  type?: InputMaybe<AssetTypeEnum>;
};

export type IQueryBeneficiaryCertificateSaasCredentialCountArgs = {
  credentialType?: InputMaybe<CredentialTypeEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<SaasCredentialsOrderByEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  saasEscrowId: Scalars['ID']['input'];
};

export type IQueryContinuityEscrowArgs = {
  continuityEscrowId: Scalars['ID']['input'];
};

export type IQueryContinuityReportArgs = {
  continuityEscrowId: Scalars['ID']['input'];
  continuityReportId: Scalars['ID']['input'];
};

export type IQueryContinuityReportsArgs = {
  continuityEscrowId: Scalars['ID']['input'];
  order?: InputMaybe<QueryOrderEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['ISO8601Date']['input']>;
  result?: InputMaybe<ContinuityReportResultsEnum>;
};

export type IQueryCustodianProfileArgs = {
  custodianProfileId: Scalars['ID']['input'];
};

export type IQueryEscrowInvitationArgs = {
  escrowInvitationId: Scalars['ID']['input'];
};

export type IQueryEscrowInvitationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryEscrowMembershipsArgs = {
  beneficiaryId: Scalars['ID']['input'];
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<EscrowMembershipsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryIntegrationArgs = {
  integrationId: Scalars['ID']['input'];
};

export type IQueryIntegrationMembersArgs = {
  integrationId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryIntegrationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<IntegrationProviderEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IntegrationStatusEnum>;
  type?: InputMaybe<IntegrationTypeEnum>;
};

export type IQueryInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type IQueryInvoicesArgs = {
  offset?: InputMaybe<Scalars['String']['input']>;
  unpaid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryLegacyReposArgs = {
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<LegacyReposOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId?: InputMaybe<Scalars['ID']['input']>;
  statusFilter?: InputMaybe<LegacyRepoMigrationStatusEnum>;
};

export type IQueryOauthReposConnArgs = {
  integrationId: Scalars['ID']['input'];
};

export type IQuerySaasCredentialsArgs = {
  credentialType?: InputMaybe<CredentialTypeEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<SaasCredentialsOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  saasEscrowId: Scalars['ID']['input'];
};

export type IQuerySaasEscrowArgs = {
  saasEscrowId: Scalars['ID']['input'];
};

export type IQuerySoftwareEscrowArgs = {
  softwareEscrowId: Scalars['ID']['input'];
};

export type IQuerySuggestedChangesArgs = {
  changeType?: InputMaybe<SuggestedChangeChangeTypeEnum>;
  creatorType?: InputMaybe<EscrowPartyTypeEnum>;
  escrowId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  partyStatus?: InputMaybe<SuggestedChangeStatusEnum>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  receiverType?: InputMaybe<EscrowPartyTypeEnum>;
  status?: InputMaybe<SuggestedChangeStatusEnum>;
};

export type IQueryTasksArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  createdAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  criticality?: InputMaybe<TaskCriticalityEnum>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentType?: InputMaybe<TaskParentTypeEnum>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TaskStatusEnum>;
};

export type IQueryUsersArgs = {
  order?: InputMaybe<QueryOrderEnum>;
  orderBy?: InputMaybe<UserColumnsEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
};

export enum QueryOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/** Autogenerated input type of ReinitAuth */
export type IReinitAuthInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReinitAuth. */
export type IReinitAuthPayload = {
  __typename?: 'ReinitAuthPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  integrationAuth?: Maybe<IIntegrationAuth>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveBackupAsset */
export type IRemoveBackupAssetInput = {
  backupAssetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveBackupAsset. */
export type IRemoveBackupAssetPayload = {
  __typename?: 'RemoveBackupAssetPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveBackup */
export type IRemoveBackupInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveBackup. */
export type IRemoveBackupPayload = {
  __typename?: 'RemoveBackupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveCustodianOperation */
export type IRemoveCustodianOperationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianOperationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCustodianOperation. */
export type IRemoveCustodianOperationPayload = {
  __typename?: 'RemoveCustodianOperationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveCustodianProfile */
export type IRemoveCustodianProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCustodianProfile. */
export type IRemoveCustodianProfilePayload = {
  __typename?: 'RemoveCustodianProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of Remove */
export type IRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of Remove. */
export type IRemovePayload = {
  __typename?: 'RemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RepoUploadCancel */
export type IRepoUploadCancelInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of RepoUploadCancel. */
export type IRepoUploadCancelPayload = {
  __typename?: 'RepoUploadCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RepoUploadComplete */
export type IRepoUploadCompleteInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: AssetContentTypeEnum;
  parts: Array<ISecureUploadPartParams>;
  repoName?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['BigInt']['input'];
  softwareEscrowId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of RepoUploadComplete. */
export type IRepoUploadCompletePayload = {
  __typename?: 'RepoUploadCompletePayload';
  asset?: Maybe<IAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RepoUploadInit */
export type IRepoUploadInitInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  numParts: Scalars['Int']['input'];
  repoName?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of RepoUploadInit. */
export type IRepoUploadInitPayload = {
  __typename?: 'RepoUploadInitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type IRepoUploadVerificationResult = {
  __typename?: 'RepoUploadVerificationResult';
  /** The asset that was verified */
  asset: IAsset;
  /** Error message if verification failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the verification was successful */
  success: Scalars['Boolean']['output'];
};

export type IReportData = {
  __typename?: 'ReportData';
  collaborators?: Maybe<Scalars['Int']['output']>;
  commitsPerDay?: Maybe<Scalars['JSON']['output']>;
  languages?: Maybe<Scalars['JSON']['output']>;
  size?: Maybe<Scalars['BigInt']['output']>;
  totalCommits?: Maybe<Scalars['Int']['output']>;
};

export enum RepositoryTypeEnum {
  Bucket = 'bucket',
  Git = 'git',
  Tfvc = 'tfvc',
}

/** Autogenerated input type of RequestBackupCredentialDownload */
export type IRequestBackupCredentialDownloadInput = {
  backupCredentialId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestBackupCredentialDownload. */
export type IRequestBackupCredentialDownloadPayload = {
  __typename?: 'RequestBackupCredentialDownloadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestBackupSecureUploadDownload */
export type IRequestBackupSecureUploadDownloadInput = {
  backupAssetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestBackupSecureUploadDownload. */
export type IRequestBackupSecureUploadDownloadPayload = {
  __typename?: 'RequestBackupSecureUploadDownloadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestBackupVersionDownload */
export type IRequestBackupVersionDownloadInput = {
  backupAssetId: Scalars['ID']['input'];
  backupVersionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestBackupVersionDownload. */
export type IRequestBackupVersionDownloadPayload = {
  __typename?: 'RequestBackupVersionDownloadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestExclusiveOffer */
export type IRequestExclusiveOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestExclusiveOffer. */
export type IRequestExclusiveOfferPayload = {
  __typename?: 'RequestExclusiveOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestUpdatePaymentPage */
export type IRequestUpdatePaymentPageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestUpdatePaymentPage. */
export type IRequestUpdatePaymentPagePayload = {
  __typename?: 'RequestUpdatePaymentPagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ISaasCredential = {
  __typename?: 'SaasCredential';
  createdAt: Scalars['ISO8601DateTime']['output'];
  credentialType: CredentialTypeEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  policy: ISaasCredentialPolicy;
  providerName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ISaasCredentialCount = {
  __typename?: 'SaasCredentialCount';
  count: Scalars['Int']['output'];
  latestCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ISaasCredentialCreateParams = {
  credentialType: CredentialTypeEnum;
  credentials: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
};

export type ISaasCredentialPage = {
  __typename?: 'SaasCredentialPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ISaasCredential>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type ISaasCredentialPolicy = {
  __typename?: 'SaasCredentialPolicy';
  remove: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaasCredentialsCreate */
export type ISaasCredentialsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  saasCredentialCreateParams: ISaasCredentialCreateParams;
  saasEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaasCredentialsCreate. */
export type ISaasCredentialsCreatePayload = {
  __typename?: 'SaasCredentialsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  saasCredential?: Maybe<ISaasCredential>;
  success: Scalars['Boolean']['output'];
};

export enum SaasCredentialsOrderByEnum {
  CreatedAt = 'created_at',
  CredentialType = 'credential_type',
  Name = 'name',
  ProviderName = 'provider_name',
  UpdatedAt = 'updated_at',
}

/** Autogenerated input type of SaasCredentialsRemove */
export type ISaasCredentialsRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  saasCredentialId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaasCredentialsRemove. */
export type ISaasCredentialsRemovePayload = {
  __typename?: 'SaasCredentialsRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  saasEscrow: ISaasEscrow;
  success: Scalars['Boolean']['output'];
};

export type ISaasEscrow = IAppProtectionInterface &
  IEscrowInterface &
  ISoftwareEscrowInterface & {
    __typename?: 'SaasEscrow';
    activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    activationNotification: Scalars['Boolean']['output'];
    adminReviewAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    agreement: IAgreement;
    agreementSettingsConfigured: Scalars['Boolean']['output'];
    app: IApp;
    assetVersionsLimit?: Maybe<Scalars['Int']['output']>;
    beneficiary?: Maybe<IBeneficiary>;
    beneficiaryActivityNotification: ActivityNotificationEnum;
    beneficiaryConfigured: Scalars['Boolean']['output'];
    beneficiaryDisruptionNotification: DisruptionNotificationEnum;
    beneficiaryDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    beneficiarySharedInformation: Scalars['Boolean']['output'];
    certificationCertified: Scalars['Boolean']['output'];
    certificationValidated: Scalars['Boolean']['output'];
    certificationVerified: Scalars['Boolean']['output'];
    changesRequested: Scalars['Boolean']['output'];
    createdAt: Scalars['ISO8601DateTime']['output'];
    currentCompanyRole?: Maybe<EscrowPartyTypeEnum>;
    depositActivity: Scalars['JSON']['output'];
    depositStatus: DepositStatusEnum;
    depositor?: Maybe<IDepositor>;
    depositorActivityNotification: ActivityNotificationEnum;
    depositorConfigured: Scalars['Boolean']['output'];
    depositorDisruptionNotification: DisruptionNotificationEnum;
    depositorDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    escrowInvitation?: Maybe<IEscrowInvitation>;
    escrowTermination?: Maybe<IEscrowTermination>;
    events: Array<IEscrowEvent>;
    id: Scalars['ID']['output'];
    lastDeposit?: Maybe<Scalars['ISO8601DateTime']['output']>;
    legalStatus: Array<ILegalStatus>;
    onboardingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    pendingActivation: Scalars['Boolean']['output'];
    policy: ISoftwareEscrowPolicy;
    productType: AppProductTypeEnum;
    reportsEnabled: Scalars['Boolean']['output'];
    reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    requiredContentTypes: Array<ContentTypeEnum>;
    signatures: Array<ISignature>;
    signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    startedBy: EscrowPartyTypeEnum;
    status: EscrowStatusEnum;
    storageRegion?: Maybe<Scalars['String']['output']>;
    taskCounts: Array<ITaskCount>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    userUpdatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** Autogenerated input type of SaasEscrowCreate */
export type ISaasEscrowCreateInput = {
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  saasEscrowCreateParams: IEscrowCreateParams;
};

/** Autogenerated return type of SaasEscrowCreate. */
export type ISaasEscrowCreatePayload = {
  __typename?: 'SaasEscrowCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  saasEscrow?: Maybe<ISaasEscrow>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SecureUploadCancel */
export type ISecureUploadCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of SecureUploadCancel. */
export type ISecureUploadCancelPayload = {
  __typename?: 'SecureUploadCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SecureUploadComplete */
export type ISecureUploadCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: AssetContentTypeEnum;
  filename: Scalars['String']['input'];
  parts: Array<ISecureUploadPartParams>;
  size: Scalars['BigInt']['input'];
  softwareEscrowId: Scalars['ID']['input'];
  uploadId: Scalars['String']['input'];
};

/** Autogenerated return type of SecureUploadComplete. */
export type ISecureUploadCompletePayload = {
  __typename?: 'SecureUploadCompletePayload';
  asset?: Maybe<IAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SecureUploadInit */
export type ISecureUploadInitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  numParts: Scalars['Int']['input'];
  softwareEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of SecureUploadInit. */
export type ISecureUploadInitPayload = {
  __typename?: 'SecureUploadInitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type ISecureUploadPartParams = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

/** Autogenerated input type of SendForReviewCustodianProfile */
export type ISendForReviewCustodianProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendForReviewCustodianProfile. */
export type ISendForReviewCustodianProfilePayload = {
  __typename?: 'SendForReviewCustodianProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianProfile: ICustodianProfile;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetupBackup */
export type ISetupBackupInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SetupBackup. */
export type ISetupBackupPayload = {
  __typename?: 'SetupBackupPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IShareFileIntegration = IIntegrationInterface & {
  __typename?: 'ShareFileIntegration';
  accountName?: Maybe<Scalars['String']['output']>;
  accountUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<IUser>;
  id: Scalars['ID']['output'];
  membersCount: Scalars['Int']['output'];
  owner?: Maybe<IUser>;
  policy: IIntegrationPolicy;
  provider: Scalars['String']['output'];
  status: IntegrationStatusEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type IShareFileIntegrationInputAttributes = {
  email: Scalars['String']['input'];
};

export type ISignature = {
  __typename?: 'Signature';
  email: Scalars['String']['output'];
  escrow: IEscrowInterface;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type ISoftwareEscrow = IAppProtectionInterface &
  IEscrowInterface &
  ISoftwareEscrowInterface & {
    __typename?: 'SoftwareEscrow';
    activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    activationNotification: Scalars['Boolean']['output'];
    adminReviewAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    agreement: IAgreement;
    agreementSettingsConfigured: Scalars['Boolean']['output'];
    app: IApp;
    assetVersionsLimit?: Maybe<Scalars['Int']['output']>;
    beneficiary?: Maybe<IBeneficiary>;
    beneficiaryActivityNotification: ActivityNotificationEnum;
    beneficiaryConfigured: Scalars['Boolean']['output'];
    beneficiaryDisruptionNotification: DisruptionNotificationEnum;
    beneficiaryDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    beneficiarySharedInformation: Scalars['Boolean']['output'];
    certificationCertified: Scalars['Boolean']['output'];
    certificationValidated: Scalars['Boolean']['output'];
    certificationVerified: Scalars['Boolean']['output'];
    changesRequested: Scalars['Boolean']['output'];
    createdAt: Scalars['ISO8601DateTime']['output'];
    currentCompanyRole?: Maybe<EscrowPartyTypeEnum>;
    depositActivity: Scalars['JSON']['output'];
    depositStatus: DepositStatusEnum;
    depositor?: Maybe<IDepositor>;
    depositorActivityNotification: ActivityNotificationEnum;
    depositorConfigured: Scalars['Boolean']['output'];
    depositorDisruptionNotification: DisruptionNotificationEnum;
    depositorDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
    escrowInvitation?: Maybe<IEscrowInvitation>;
    escrowTermination?: Maybe<IEscrowTermination>;
    events: Array<IEscrowEvent>;
    id: Scalars['ID']['output'];
    lastDeposit?: Maybe<Scalars['ISO8601DateTime']['output']>;
    legalStatus: Array<ILegalStatus>;
    onboardingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    pendingActivation: Scalars['Boolean']['output'];
    policy: ISoftwareEscrowPolicy;
    productType: AppProductTypeEnum;
    reportsEnabled: Scalars['Boolean']['output'];
    reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    requiredContentTypes: Array<ContentTypeEnum>;
    signatures: Array<ISignature>;
    signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
    startedBy: EscrowPartyTypeEnum;
    status: EscrowStatusEnum;
    storageRegion?: Maybe<Scalars['String']['output']>;
    taskCounts: Array<ITaskCount>;
    updatedAt: Scalars['ISO8601DateTime']['output'];
    userUpdatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** Autogenerated input type of SoftwareEscrowActivate */
export type ISoftwareEscrowActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of SoftwareEscrowActivate. */
export type ISoftwareEscrowActivatePayload = {
  __typename?: 'SoftwareEscrowActivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow?: Maybe<ISoftwareEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SoftwareEscrowCreate */
export type ISoftwareEscrowCreateInput = {
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowCreateParams: IEscrowCreateParams;
};

/** Autogenerated return type of SoftwareEscrowCreate. */
export type ISoftwareEscrowCreatePayload = {
  __typename?: 'SoftwareEscrowCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow?: Maybe<ISoftwareEscrow>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SoftwareEscrowEnableReports */
export type ISoftwareEscrowEnableReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of SoftwareEscrowEnableReports. */
export type ISoftwareEscrowEnableReportsPayload = {
  __typename?: 'SoftwareEscrowEnableReportsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow?: Maybe<ISoftwareEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export type ISoftwareEscrowInterface = {
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  activationNotification: Scalars['Boolean']['output'];
  adminReviewAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  agreement: IAgreement;
  agreementSettingsConfigured: Scalars['Boolean']['output'];
  app: IApp;
  assetVersionsLimit?: Maybe<Scalars['Int']['output']>;
  beneficiary?: Maybe<IBeneficiary>;
  beneficiaryActivityNotification: ActivityNotificationEnum;
  beneficiaryConfigured: Scalars['Boolean']['output'];
  beneficiaryDisruptionNotification: DisruptionNotificationEnum;
  beneficiaryDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
  beneficiarySharedInformation: Scalars['Boolean']['output'];
  certificationCertified: Scalars['Boolean']['output'];
  certificationValidated: Scalars['Boolean']['output'];
  certificationVerified: Scalars['Boolean']['output'];
  changesRequested: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentCompanyRole?: Maybe<EscrowPartyTypeEnum>;
  depositActivity: Scalars['JSON']['output'];
  depositStatus: DepositStatusEnum;
  depositor?: Maybe<IDepositor>;
  depositorActivityNotification: ActivityNotificationEnum;
  depositorConfigured: Scalars['Boolean']['output'];
  depositorDisruptionNotification: DisruptionNotificationEnum;
  depositorDisruptionNotificationGracePeriod?: Maybe<DisruptionNotificationGracePeriodEnum>;
  escrowInvitation?: Maybe<IEscrowInvitation>;
  escrowTermination?: Maybe<IEscrowTermination>;
  events: Array<IEscrowEvent>;
  id: Scalars['ID']['output'];
  lastDeposit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  legalStatus: Array<ILegalStatus>;
  onboardingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pendingActivation: Scalars['Boolean']['output'];
  policy: ISoftwareEscrowPolicy;
  productType: AppProductTypeEnum;
  reportsEnabled: Scalars['Boolean']['output'];
  reportsEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  requiredContentTypes: Array<ContentTypeEnum>;
  signatures: Array<ISignature>;
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startedBy: EscrowPartyTypeEnum;
  status: EscrowStatusEnum;
  storageRegion?: Maybe<Scalars['String']['output']>;
  taskCounts: Array<ITaskCount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userUpdatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ISoftwareEscrowPolicy = {
  __typename?: 'SoftwareEscrowPolicy';
  activate: Scalars['Boolean']['output'];
  createAgreementSuggestedChange: Scalars['Boolean']['output'];
  createBeneficiary: Scalars['Boolean']['output'];
  createBeneficiarySuggestedChange: Scalars['Boolean']['output'];
  createDepositSuggestedChange: Scalars['Boolean']['output'];
  createDepositorSuggestedChange: Scalars['Boolean']['output'];
  createNotificationSuggestedChange: Scalars['Boolean']['output'];
  deferActivation: Scalars['Boolean']['output'];
  depositAssets: Scalars['Boolean']['output'];
  enableReports: Scalars['Boolean']['output'];
  inviteBeneficiary: Scalars['Boolean']['output'];
  inviteDepositor: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  remove: Scalars['Boolean']['output'];
  requestTermination: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  updateBeneficiaryNotifications: Scalars['Boolean']['output'];
  updateDepositorNotifications: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SoftwareEscrowUpdateContentTypes */
export type ISoftwareEscrowUpdateContentTypesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  requiredContentTypes: Array<ContentTypeEnum>;
  softwareEscrowId: Scalars['ID']['input'];
};

/** Autogenerated return type of SoftwareEscrowUpdateContentTypes. */
export type ISoftwareEscrowUpdateContentTypesPayload = {
  __typename?: 'SoftwareEscrowUpdateContentTypesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow?: Maybe<ISoftwareEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SoftwareEscrowUpdate */
export type ISoftwareEscrowUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  softwareEscrowId: Scalars['ID']['input'];
  softwareEscrowParams: ISoftwareEscrowUpdateParams;
};

export type ISoftwareEscrowUpdateParams = {
  activationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  assetVersionsLimit?: InputMaybe<Scalars['Int']['input']>;
  beneficiarySharedInformation?: InputMaybe<Scalars['Boolean']['input']>;
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SoftwareEscrowUpdate. */
export type ISoftwareEscrowUpdatePayload = {
  __typename?: 'SoftwareEscrowUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  softwareEscrow?: Maybe<ISoftwareEscrowInterface>;
  success: Scalars['Boolean']['output'];
};

export type ISubscription = {
  __typename?: 'Subscription';
  /** Subscribe to repo upload verification events for a specific backup asset */
  backupRepoUploadVerificationFinished?: Maybe<IBackupRepoUploadVerificationResult>;
  /** Subscribe to repo upload verification events for a specific asset */
  repoUploadVerificationFinished?: Maybe<IRepoUploadVerificationResult>;
};

export type ISubscriptionBackupRepoUploadVerificationFinishedArgs = {
  backupAssetId: Scalars['ID']['input'];
};

export type ISubscriptionRepoUploadVerificationFinishedArgs = {
  assetId: Scalars['ID']['input'];
};

export type ISuggestChange = {
  __typename?: 'SuggestChange';
  changeType: SuggestedChangeChangeTypeEnum;
  creatorType: EscrowPartyTypeEnum;
  escrow: IEscrowInterface;
  id: Scalars['ID']['output'];
  partyStatus?: Maybe<SuggestedChangeStatusEnum>;
  payload: Scalars['JSON']['output'];
  policy: ISuggestedChangePolicy;
  receiverType?: Maybe<EscrowPartyTypeEnum>;
  status: SuggestedChangeStatusEnum;
};

export type ISuggestChangePage = {
  __typename?: 'SuggestChangePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ISuggestChange>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum SuggestedChangeChangeTypeEnum {
  AgreementSuggestedChange = 'AgreementSuggestedChange',
  BeneficiarySuggestedChange = 'BeneficiarySuggestedChange',
  DepositSuggestedChange = 'DepositSuggestedChange',
  DepositorSuggestedChange = 'DepositorSuggestedChange',
  EnvironmentSuggestedChange = 'EnvironmentSuggestedChange',
  NotificationSuggestedChange = 'NotificationSuggestedChange',
}

/** Autogenerated input type of SuggestedChangeCreate */
export type ISuggestedChangeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  escrowId: Scalars['ID']['input'];
  suggestedChangeParams: ISuggestedChangeParams;
};

/** Autogenerated return type of SuggestedChangeCreate. */
export type ISuggestedChangeCreatePayload = {
  __typename?: 'SuggestedChangeCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  suggestedChange?: Maybe<ISuggestChange>;
};

export type ISuggestedChangeParams = {
  agreementSuggestedChange?: InputMaybe<IAgreementChangeParams>;
  beneficiarySuggestedChange?: InputMaybe<IBeneficiaryChangeParams>;
  depositSuggestedChange?: InputMaybe<IDepositChangeParams>;
  depositorSuggestedChange?: InputMaybe<IDepositorChangeParams>;
  environmentSuggestedChange?: InputMaybe<IEnvironmentChangeParams>;
  notificationSuggestedChange?: InputMaybe<INotificationChangeParams>;
};

export type ISuggestedChangePolicy = {
  __typename?: 'SuggestedChangePolicy';
  review: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SuggestedChangeReview */
export type ISuggestedChangeReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  suggestedChangeId: Scalars['ID']['input'];
  verdict: SuggestedChangeVerdictEnum;
};

/** Autogenerated return type of SuggestedChangeReview. */
export type ISuggestedChangeReviewPayload = {
  __typename?: 'SuggestedChangeReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  suggestedChange: ISuggestChange;
};

export enum SuggestedChangeStatusEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Autogenerated input type of SuggestedChangeUpdate */
export type ISuggestedChangeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  suggestedChangeId: Scalars['ID']['input'];
  suggestedChangeParams: ISuggestedChangeParams;
};

/** Autogenerated return type of SuggestedChangeUpdate. */
export type ISuggestedChangeUpdatePayload = {
  __typename?: 'SuggestedChangeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  suggestedChange: ISuggestChange;
};

export enum SuggestedChangeVerdictEnum {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum SyncStatusEnum {
  Active = 'active',
  AwaitingSync = 'awaiting_sync',
  Deleted = 'deleted',
  Disconnected = 'disconnected',
  GracePeriod = 'grace_period',
  Pending = 'pending',
}

export type ITask = {
  __typename?: 'Task';
  createdAt: Scalars['ISO8601DateTime']['output'];
  criticality: TaskCriticalityEnum;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parentId: Scalars['ID']['output'];
  parentType: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recordId: Scalars['ID']['output'];
  recordType: Scalars['String']['output'];
};

export type ITaskCount = {
  __typename?: 'TaskCount';
  count: Scalars['Int']['output'];
  criticality: TaskCriticalityEnum;
};

export enum TaskCriticalityEnum {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export type ITaskPage = {
  __typename?: 'TaskPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ITask>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export enum TaskParentTypeEnum {
  App = 'App',
  Company = 'Company',
  CustodianProfile = 'CustodianProfile',
  Escrow = 'Escrow',
}

export enum TaskStatusEnum {
  Read = 'read',
  Unread = 'unread',
}

/** Autogenerated input type of TerminateBackup */
export type ITerminateBackupInput = {
  backupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TerminateBackup. */
export type ITerminateBackupPayload = {
  __typename?: 'TerminateBackupPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TerminateCustodianProfile */
export type ITerminateCustodianProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminateCustodianProfile. */
export type ITerminateCustodianProfilePayload = {
  __typename?: 'TerminateCustodianProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianTermination?: Maybe<ICustodianTermination>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of Toggle */
export type IToggleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of Toggle. */
export type ITogglePayload = {
  __typename?: 'TogglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  integration?: Maybe<IIntegrationInterface>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TransferCompanyOwnership */
export type ITransferCompanyOwnershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferCompanyOwnership. */
export type ITransferCompanyOwnershipPayload = {
  __typename?: 'TransferCompanyOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<IUser>;
};

/** Autogenerated input type of UpdateBackup */
export type IUpdateBackupInput = {
  backupId: Scalars['ID']['input'];
  backupParams: IBackupUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBackup. */
export type IUpdateBackupPayload = {
  __typename?: 'UpdateBackupPayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateBackupStorage */
export type IUpdateBackupStorageInput = {
  backupId: Scalars['ID']['input'];
  backupParams: IBackupStorageUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBackupStorage. */
export type IUpdateBackupStoragePayload = {
  __typename?: 'UpdateBackupStoragePayload';
  backup: IBackup;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateBillingAddress */
export type IUpdateBillingAddressInput = {
  billingAddress: IBillingAddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBillingAddress. */
export type IUpdateBillingAddressPayload = {
  __typename?: 'UpdateBillingAddressPayload';
  billingAddress?: Maybe<IBillingAddress>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCompany */
export type IUpdateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyInput: ICompanyInput;
};

/** Autogenerated return type of UpdateCompany. */
export type IUpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ICompany>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCustodianAssets */
export type IUpdateCustodianAssetsInput = {
  assetsInput: Array<ICustodianAssetCreateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianProfileId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCustodianAssets. */
export type IUpdateCustodianAssetsPayload = {
  __typename?: 'UpdateCustodianAssetsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianAssets?: Maybe<Array<ICustodianAsset>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCustodianOperation */
export type IUpdateCustodianOperationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  custodianOperationId: Scalars['ID']['input'];
  custodianOperationParams: ICustodianOperationUpdateInput;
};

/** Autogenerated return type of UpdateCustodianOperation. */
export type IUpdateCustodianOperationPayload = {
  __typename?: 'UpdateCustodianOperationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  custodianOperation: ICustodianOperation;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCustomIntegration */
export type IUpdateCustomIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customIntegrationInput: ICustomIntegrationUpdateInputAttributes;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCustomIntegration. */
export type IUpdateCustomIntegrationPayload = {
  __typename?: 'UpdateCustomIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customIntegration?: Maybe<ICustomIntegration>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProfileInfo */
export type IUpdateProfileInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProfileInfo. */
export type IUpdateProfileInfoPayload = {
  __typename?: 'UpdateProfileInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  profile?: Maybe<IProfile>;
  success: Scalars['Boolean']['output'];
};

export type IUser = {
  __typename?: 'User';
  contacts?: Maybe<Array<IContact>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policy: IUserPolicy;
  role: UserRoleEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum UserColumnsEnum {
  CreatedAt = 'created_at',
  Email = 'email',
  Name = 'name',
  Phone = 'phone',
  Role = 'role',
}

export type IUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
};

export type IUserPage = {
  __typename?: 'UserPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<IUser>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type IUserPolicy = {
  __typename?: 'UserPolicy';
  remove: Scalars['Boolean']['output'];
  transferOwnership: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};

export enum UserRoleEnum {
  Admin = 'admin',
  Owner = 'owner',
  User = 'user',
}
